<form class="edit-form place-an-order" #orderFrom="ngForm" role="presentation" autocomplete="off" novalidate (submit)="submitItem()">
  <input type="password" name="fakepassword" id="fakepassword" style="display:none">
  <div class="container-fluid">
    <div class="row">
        <!--main box-->
        <div class="col-md-12 col-sm-12 main-box" [ngClass]="[!isTabletLandscape ? 'col-lg-6' : '']" *ngIf="!isShow">
          <app-card [title]="isQuote ? ('admin.quote.detail'|translate ) : ('admin.order.detail'|translate)">
            <!--Dealer user-->
            <div class="card-body">
              <div class="form-group" *ngIf="canLoadOrderUser()">
                <div class="container">
                  <div class="">
                    <div class="row">
                      <label class="col-sm-3 col-form-label no-padding-right left-pos">
                         <span class="labelWithToolTip no-padding-y">
                            {{'doctrine.attributes.dealer'|translate}}<span class="star">*</span>
                         </span>
                        <span class="tooltip-item ">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place">
                          <ng-container>
                            <div>
                            {{'doctrine.order.select_dealer'|translate}}
                            </div>
                          </ng-container>
                          </span>
                      </span>
                      </label>
                      <div class="col-sm-9" >
                        <ng-select #orderUser="ngModel" name="orderUser"
                                   [items]="selectedUsers"
                                   [required]="canLoadOrderUser()"
                                   [(ngModel)]="order.user.id"
                                   (change)="setOrderUser($event)"
                                   bindLabel="companyName"
                                   bindValue="id"
                                   placeholder="{{'global.search'|translate}} {{'admin.dealer.show.delivery_dealers'|translate}}"
                                   [clearable]="false"
                                   autofocus
                                   [typeahead]="usersTypeahead">
                          <ng-template ng-typetosearch-tmp>
                            <div class="ng-option disabled text-black-50">
                              {{'global.search'|translate}} {{'admin.dealer.show.delivery_dealers'|translate}}
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled text-black-50">
                              {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
                            </div>
                          </ng-template>
                          <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled text-black-50">
                              {{'doctrine.order.search_for'|translate}} {{searchTerm}}
                            </div>
                          </ng-template>
                        </ng-select>
                        <div class="messages text-danger"
                             *ngIf="orderItemFormChecked() && (!orderUser.dirty && !isEdit)">
                          {{'errors.required'|translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Reference-->
              <div class="form-group no-margin-bottom">
                <div class="container">
                  <div class="">
                    <div class="row">
                      <label class="col-sm-3 col-form-label no-padding-right left-pos">
                         <span class="labelWithToolTip no-padding-y">
                            {{'doctrine.order.reference'|translate}}<span class="star">*</span>
                         </span>
                        <!--tooltip-item-->
                        <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.reference_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-sm-9" >
                        <input type="text" name="referenceItem" #referenceItem="ngModel" [(ngModel)]="order.reference"
                               class="form-control" autofocus required>
                        <div class="messages text-danger"
                             *ngIf="referenceItem.invalid && orderItemFormChecked() && referenceItem.errors?.required">
                          {{'errors.required'|translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Remark-->
              <div class="form-group no-margin-bottom">
                <div class="container">
                  <div class="">
                    <div class="row">
                      <label class="col-sm-3 col-form-label no-padding-right left-pos">
                         <span class="labelWithToolTip no-padding-y">
                            {{'admin.order.remark' |translate}}
                         </span>
                        <!--tooltip-item-->
                        <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.remark_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-sm-9" *ngIf="!isShow" >
                        <form novalidate style="margin-top: 5px;">
                          <input
                            type="checkbox"
                            name="haveRemark"
                            [(ngModel)]="haveRemark"
                            (ngModelChange)="clearRemark()"
                          >
                          <label class="border-checkbox-label mb-0"> {{'admin.dealer.order.have_remark'|translate}}
                          </label>
                        </form>
                        <section *ngIf="haveRemark" style="margin-top: 10px">
                          <textarea maxlength="150" rows="3" type="text" name="remarkItem" #remarkItem="ngModel" [(ngModel)]="order.remark"
                                    class="form-control" autofocus></textarea>
                          <div class="messages text-danger"
                               *ngIf="remarkItem.invalid && orderItemFormChecked() && remarkItem.errors?.required">
                            {{'errors.required'|translate}}
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
          <div *ngIf="!isBackoffice || (order.user && order.user.country)">
            <app-card [cardOptionBtnValue]="''"
                      [simpleBtnCustomClass]="'btn btn-link pe-0'"
                      [cardOptionBtnIcon]="'fa fa-trash fa-fw'"
                      (outputButton)="deleteOrderItem(i)"
                      *ngFor="let orderItem of order.orderItems;let i=index;"
                      [title]="'admin.order.article'|translate:{'number': i+1}"
                      [cardOptionBtn]="(i === 0 && order.orderItems.length === 1 ? false :order.orderItems.length)"
            >
              <!-- Article-->
              <!--totalArticle-->
              <span class="totalArticle" data-testid="article-subtotal" [ngClass]="(i === 0 && order.orderItems.length === 1 ? 'first-article' : '')"    *ngIf="(customerPrice && orderItem.totalArticleCustomerPrice != 0 ) || (!customerPrice && orderItem.totalArticleDealerPrice != 0 )">
            {{(customerPrice ? orderItem.totalArticleCustomerPrice : orderItem.totalArticleDealerPrice)| CustomCurrency }}
          </span>
              <span class="totalArticle dash-article" *ngIf="(customerPrice && orderItem.totalArticleCustomerPrice == 0 ) || (!customerPrice && orderItem.totalArticleDealerPrice == 0 )">
  -
          </span>
              <!--Collection-->
              <div class="card-body">
                <!--one col form select type-->
                <div class="form-group" [ngClass]="orderItem.collection?'':'no-margin-bottom'">
                  <div class="container">
                    <div class="">
                      <div class="row">
                        <label class="col-sm-3 col-form-label no-padding-right left-pos">
                         <span class="labelWithToolTip no-padding-y">
                          {{'doctrine.attributes.collection'|translate}}
                           <span class="star">*</span>
                         </span>
                          <!--tooltip-item-->
                          <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place">
                          <ng-container>
                            <div>
                              {{'admin.dealer.order.collection_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>

                        </label>
                        <div class="col-sm-9">
                          <ng-select #collectionInput
                            [name]="'collection'+i+orderItem.random"
                            #collection="ngModel"
                            [ngModel]="orderItem.collection"
                            (ngModelChange)="onCollectionChange(i, $event)"
                            [items]="orderItem.collections"
                            bindValue="id"
                            bindLabel="name"
                            [placeholder]="'global.selectbox_placeholder'|translate"
                            [searchable]="true"
                            (search)="filterCollection(i, $event)"
                            [autofocus]="[referenceItem.dirty, collectionInput]"
                            (click)="disableAutofill($event)"
                            required>
                          </ng-select>

                          <div class="messages text-danger"
                               *ngIf="collection.invalid && orderItemFormChecked(i) && collection.errors?.required">
                            {{'errors.required'|translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                <!--Model-->
              <div class="card-body pt-0">
                <!--one col form select type-->
                <div class="form-group no-margin-bottom" *ngIf="orderItem.collection">
                  <div class="container">
                      <div class="row">
                        <label class="col-sm-3 col-form-label no-padding-right left-pos">
                      <span class="labelWithToolTip no-padding-y">
                        <ng-container *ngIf="getCustomLabel('modelLabel', orderItem)">{{ getCustomLabel('modelLabel', orderItem )}}</ng-container>
                        <ng-container *ngIf="!getCustomLabel('modelLabel', orderItem)">{{'doctrine.attributes.model'|translate}}</ng-container>
                        <span class="star">*</span>
                         </span>
                          <!--tooltip-item-->
                          <span class="tooltip-item" *ngIf="orderItem.modelObj?.message">
                            <span class="tooltipBox">
                              <i class="fa fa-info-circle fa-2x color-blue" aria-hidden="true"></i>
                            </span>
                            <span class="desc-place">
                              <ng-container>
                                <div>
                                  {{orderItem.modelObj?.message}}
                                </div>
                              </ng-container>
                            </span>
                          </span>
                          <span class="tooltip-item">
                            <span class="tooltipBox">
                              <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                            </span>
                            <span class="desc-place">
                              <ng-container>
                                <div>
                                  {{'admin.dealer.order.model_description'|translate}}
                                </div>
                              </ng-container>
                            </span>
                          </span>
                        </label>
                        <div class="col-sm-9">
                          <div class="d-flex">
                            <div [class]="orderItem.modelObj && orderItem.modelObj.styles && orderItem.modelObj.styles.length >0 ? 'col-6 flex-fill  ps-0 pe-1':'col-12 flex-fill p-0'">
                              <ng-select
                                [name]="'model'+i+orderItem.random"
                                #model="ngModel"
                                [(ngModel)]="orderItem.model"
                                (change)="getStyles(i,orderItem.model);"
                                (clear)="getStyles(i,orderItem.model);"
                                [items]="orderItem.models"
                                bindValue="id"
                                [placeholder]="'global.selectbox_placeholder'|translate"
                                bindLabel="name"
                                (search)="filterModel(i, $event)"
                                required>
                              </ng-select>
                              <div class="messages text-danger"
                                   *ngIf="model.invalid && orderItemFormChecked(i) && model.errors?.required">
                                {{'errors.required'|translate}}
                              </div>
                            </div>
                            <div *ngIf="orderItem.modelObj  && orderItem.modelObj.styles && orderItem.modelObj.styles.length >0" class="col-6 flex-fill ps-1 pe-0" >
                              <ng-select
                                [name]="'style'+i+orderItem.random"
                                #style="ngModel"
                                [(ngModel)]="orderItem.style"
                                [items]="orderItem.styles"
                                bindValue="id"
                                [placeholder]="'global.selectbox_placeholder'|translate"
                                bindLabel="name"
                                (search)="filterStyle(i, $event)"
                                (clear)="getProducts(i,orderItem.model,orderItem.style);"
                                (change)="getProducts(i,orderItem.model,orderItem.style)"
                                required>
                              </ng-select>
                              <div class="messages text-danger"
                                   *ngIf="style.invalid && orderItemFormChecked(i) && style.errors?.required">
                                {{'errors.required'|translate}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
                <ng-container
                  *ngIf="(orderItem.modelObj && ((orderItem.modelObj.styles && orderItem.modelObj.styles.length === 0) || orderItem.style))">
                  <ng-container
                    *ngFor="let productItem of orderItem.orderItemProducts;let j=index;let lastProductsIndex=last;">
                    <div class=" margin-top " >
                      <div class="card-header">
                          <strong class="box-title">{{'admin.order.element'|translate}} {{orderItemCount(j)}} </strong>
                        <!-- delete if have 2 or more product-->
                        <div *ngIf="orderItem.orderItemProducts.length>1">
                          <button class="btn-link btn-remove-padding" (click)="deleteOrderProduct(i,j)" type="button">
                            <i class="fa fa-trash fa-fw'"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <!--insert product col-->
                      <div class="margin-top bg-light text-dark">
                        <div class="card-body fabrics">
                          <div class="container">
                            <!--form with  with img  -->
                            <div class="row">
                              <!--form-box-->
                              <div class="no-padding-left" [ngClass]="productItem.productObj && productItem.productObj.image ? 'has-image col-md-10 col-sm-8': 'col-md-12 col-sm-12'">
                                <!--Product-->
                                <div class="form-group no-margin-bottom ">
                                  <div class="container" >
                                    <div class="row" >
                                      <label  class=" col-form-label no-padding-right left-pos" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 ps-0 custom-padding'">
                                    <span class="labelWithToolTip no-padding-y">
                                      {{elementLabel('productLabel', orderItem, productItem, 'doctrine.attributes.product', 'admin.dealer.order.carpet_product')}}
                                      <span class="star">*</span>
                                    </span>
                                        <!--tooltip-item-->
                                        <span class="tooltip-item">
                                       <span class="tooltipBox">
                                         <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                       </span>
                                      <span class="desc-place">
                                          <ng-container>
                                            <div>
                                             {{'admin.dealer.order.product_description'|translate}}
                                            </div>
                                          </ng-container>
                                      </span>
                                     </span>
                                      </label>
                                      <div  [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9 p-0'">
                                        <div class="d-flex">
                                          <div class="col-sm-8 ps-0" >
                                            <ng-select
                                              [name]="'product'+productItem.random"
                                              #product="ngModel"
                                              [(ngModel)]="productItem.product"
                                              (change)="getPackages(i,j,productItem.product); onProductChange(i, j, productItem);"
                                              [placeholder]="'global.selectbox_placeholder'|translate"
                                              bindValue="id"
                                              bindLabel="name"
                                              (search)="filterProduct(i, $event)"
                                              [items]="orderItem.products"
                                              [clearable]="true"
                                              (clear)="onProductClear(i, j)"
                                              required>
                                            </ng-select>
                                            <div class="messages text-danger"
                                                 *ngIf="orderItem.modelObj && orderItem.modelObj.productCount===0">
                                              {{'errors.do_not_have_product'|translate}}
                                            </div>
                                            <div class="messages text-danger"
                                                 *ngIf="product.invalid && orderItemFormChecked(i) && product.errors?.required">
                                              {{'errors.required'|translate}}
                                            </div>
                                          </div>
                                          <div class="col-sm-4 pe-0">
                                            <!--amount-->
                                            <input class="form-control form-control-normal"
                                                   type="number"
                                                   [name]="'amount'+productItem.random"
                                                   #amount="ngModel"
                                                   [(ngModel)]="productItem.amount"
                                                   [min]="1"
                                                   [max]="30"
                                                   step="1"
                                                   min="1"
                                                   max="30"
                                                   pattern="^[^.]+"
                                                   (input)="getAllTotal(i); onProductChange(i,j,productItem,true)"
                                                   required>

                                            <div class="messages text-danger"
                                                 *ngIf="amount.invalid && orderItemFormChecked(i) && amount.errors?.pattern">
                                              {{'errors.invalid'|translate}}
                                            </div>
                                            <div class="messages text-danger"
                                                 *ngIf="amount.invalid && orderItemFormChecked(i) && amount.errors?.required">
                                              {{'errors.required'|translate}}
                                            </div>
                                            <div class="messages text-danger"
                                                 *ngIf="amount.errors?.min || amount.errors?.max">
                                              {{'errors.range'|translate:{min: 1, max: 30} }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class=" no-padding-right no-padding-y" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 p-0'"></div>
                                      <div class="margin-top pt-2" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9'"
                                           *ngIf="this.order.orderItems[i].orderItemProducts[j].stockAmountAlert && this.order.orderItems[i].orderItemProducts[j].stockAmountAlert.shouldShow">
                                        <div
                                          [ngClass]="[this.order.orderItems[i].orderItemProducts[j].stockAmountAlert.shouldShow?this.order.orderItems[i].orderItemProducts[j].stockAmountAlert.color:'']">
                                          <div>
                                            <i
                                              class="fa fa-circle"></i>&nbsp;{{this.order.orderItems[i].orderItemProducts[j].stockAmountAlert.message}}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                                <!--    carpet size — the slot the Fabric selector occupies for a sofa (FR-023)-->
                                <div class="form-group no-margin-bottom margin-top" *ngIf="isRugProduct(productItem)">
                                  <div class="container">
                                    <div class="row">
                                      <label class="col-form-label no-padding-right left-pos"
                                             [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 ps-0 custom-padding'">
                                        <span class="labelWithToolTip no-padding-y">
                                          {{elementLabel('sizeLabel', orderItem, productItem, 'admin.dealer.order.carpet_size', 'admin.dealer.order.carpet_size')}}
                                          <span class="star">*</span>
                                        </span>
                                      </label>
                                      <div [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9 p-0'">
                                        <div class="d-flex">
                                          <!--preset dropdown: the only control in fixed mode, so it takes the width the
                                               (hidden) custom inputs would otherwise leave empty (D12); a quick-fill
                                               alongside them in custom mode, so it stays narrow there instead.
                                               flex-fill on every control so the group always spans the full 12 columns
                                               of the wrapper, and so lines up with the Rug row's col-sm-8 + col-sm-4,
                                               in all four render modes (D12).-->
                                          <div class="flex-fill" [ngClass]="rugHasCustomInputs(productItem) ? 'col-sm-4 ps-0' : 'col-sm-6 p-0'" *ngIf="rugPresets(productItem).length">
                                            <ng-select
                                              [name]="'carpetSize'+productItem.random"
                                              [(ngModel)]="productItem.selectedSizeId"
                                              (change)="onRugPresetChange(i, j, productItem)"
                                              [placeholder]="'global.selectbox_placeholder'|translate"
                                              bindValue="id"
                                              [items]="rugPresets(productItem)"
                                              [clearable]="rugHasCustomInputs(productItem)"
                                              [required]="!rugHasCustomInputs(productItem)">
                                              <ng-template ng-label-tmp ng-option-tmp let-size="item">
                                                {{rugPresetLabel(size)}}
                                              </ng-template>
                                            </ng-select>
                                          </div>
                                          <!--two cm inputs: custom mode only-->
                                          <ng-container *ngIf="rugHasCustomInputs(productItem)">
                                            <div class="col-sm-3 flex-fill ps-0">
                                              <input class="form-control form-control-normal"
                                                     type="number"
                                                     step="1"
                                                     [name]="'carpetWidth'+productItem.random"
                                                     #carpetWidth="ngModel"
                                                     [(ngModel)]="productItem.widthCm"
                                                     [min]="rugMinWidth(productItem)"
                                                     [max]="rugMaxWidth(productItem)"
                                                     [placeholder]="'admin.dealer.order.carpet_width_cm'|translate"
                                                     pattern="^[0-9]+$"
                                                     (input)="onRugSizeChange(i, j, productItem, true)"
                                                     required>
                                              <!-- D12: reserve the message line's height whether or not one is
                                                   showing, so the price box below doesn't jump when validation fires.
                                                   D25: the pattern message uses errors.invalid — the key this file
                                                   already uses elsewhere for the same job. `errors.number` had no
                                                   entry in either language, so it printed itself to the user. Do not
                                                   point these back at a key that does not exist in the API's
                                                   translation set. -->
                                              <div class="carpet-field-message">
                                                <div class="messages text-danger"
                                                     *ngIf="carpetWidth.invalid && orderItemFormChecked(i) && carpetWidth.errors?.required">
                                                  {{'errors.required'|translate}}
                                                </div>
                                                <div class="messages text-danger"
                                                     *ngIf="carpetWidth.errors?.pattern">{{'errors.invalid'|translate}}</div>
                                                <div class="messages text-danger"
                                                     *ngIf="carpetWidth.errors?.min || carpetWidth.errors?.max">
                                                  {{rugSizeRangeKey(productItem, 'width')|translate:{min: rugMinWidth(productItem), max: rugMaxWidth(productItem)} }}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-sm-3 flex-fill ps-0 pe-0">
                                              <input class="form-control form-control-normal"
                                                     type="number"
                                                     step="1"
                                                     [name]="'carpetLength'+productItem.random"
                                                     #carpetLength="ngModel"
                                                     [(ngModel)]="productItem.lengthCm"
                                                     [min]="rugMinLength(productItem)"
                                                     [max]="rugMaxLength(productItem)"
                                                     [placeholder]="'admin.dealer.order.carpet_length_cm'|translate"
                                                     pattern="^[0-9]+$"
                                                     (input)="onRugSizeChange(i, j, productItem, true)"
                                                     required>
                                              <div class="carpet-field-message">
                                                <div class="messages text-danger"
                                                     *ngIf="carpetLength.invalid && orderItemFormChecked(i) && carpetLength.errors?.required">
                                                  {{'errors.required'|translate}}
                                                </div>
                                                <div class="messages text-danger"
                                                     *ngIf="carpetLength.errors?.pattern">{{'errors.invalid'|translate}}</div>
                                                <div class="messages text-danger"
                                                     *ngIf="carpetLength.errors?.min || carpetLength.errors?.max">
                                                  {{rugSizeRangeKey(productItem, 'length')|translate:{min: rugMinLength(productItem), max: rugMaxLength(productItem)} }}
                                                </div>
                                              </div>
                                            </div>
                                          </ng-container>
                                          <!--a fixed-size rug with no presets has no control at all; say so rather than render nothing-->
                                          <div class="col-sm-8 messages text-danger"
                                               *ngIf="!rugHasCustomInputs(productItem) && !rugPresets(productItem).length">
                                            {{'admin.dealer.order.carpet_no_sizes'|translate}}
                                          </div>
                                        </div>
                                        <!--live metre equivalent, never editable (FR-021). Directly under the row
                                             rather than in it: as a col-sm-2 grid column it took the two columns the
                                             width/length inputs need to reach the shared right edge (D12). It appears
                                             on the same keystroke as the price box below, so it adds no new jump.-->
                                        <div class="text-muted" *ngIf="productItem.widthCm > 0 && productItem.lengthCm > 0">
                                          = {{toMetres(productItem.widthCm)}} × {{toMetres(productItem.lengthCm)}} m
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!--    carpet options — shape / finishing / colour, PER ELEMENT.
                                        Placed directly under this element's size row so it is obvious
                                        that each element carries its own: two elements mean two sets of
                                        choices, while one element with a higher quantity means one set. -->
                                <div class="form-group no-margin-bottom carpet-option-row"
                                     *ngFor="let carpetGroup of carpetOptionGroupsFor(productItem)">
                                  <div class="container">
                                    <div class="row">
                                      <label class="col-form-label no-padding-right left-pos"
                                             [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 ps-0 custom-padding'">
                                        <span class="labelWithToolTip no-padding-y">
                                          {{carpetOptionLabel(carpetGroup)}}
                                          <span class="star" *ngIf="carpetOptionRequired(carpetGroup)">*</span>
                                        </span>
                                      </label>
                                      <div [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9 p-0'">
                                        <ng-select
                                          [name]="'carpetOption' + carpetGroup.option.id + productItem.random"
                                          #carpetOptionInput="ngModel"
                                          [ngModel]="carpetOptionValue(productItem, carpetGroup)"
                                          (ngModelChange)="setCarpetOptionValue(productItem, carpetGroup, $event)"
                                          (change)="onCarpetOptionChange(i)"
                                          [placeholder]="'global.selectbox_placeholder'|translate"
                                          bindValue="id"
                                          bindLabel="name"
                                          [items]="carpetOptionChoices(carpetGroup)"
                                          [clearable]="true"
                                          [required]="carpetOptionRequired(carpetGroup)">
                                        </ng-select>
                                        <div class="messages text-danger"
                                             *ngIf="carpetOptionInput.invalid && orderItemFormChecked(i) && carpetOptionInput.errors?.required">
                                          {{'errors.required'|translate}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!--    carpet price box — display only; the server recomputes the same numbers (FR-011–FR-014)-->
                                <ng-container *ngIf="isRugProduct(productItem)">
                                  <ng-container *ngIf="productItem.carpetCost as carpet">
                                    <div class="form-group no-margin-bottom margin-top">
                                      <div class="container">
                                        <div class="row">
                                          <label class="col-form-label no-padding-right left-pos"
                                                 [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 ps-0 custom-padding'">
                                            <span class="labelWithToolTip no-padding-y">
                                              <span>{{'admin.dealer.order.carpet_price'|translate}}</span>
                                            </span>
                                          </label>
                                          <div [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9 p-0'">
                                            <table class="table table-sm mb-0 carpet-price-table">
                                              <tr>
                                                <!--On a bypassed line "Material (x m2)" is wrong: nothing was
                                                    calculated from area. The dealer must be able to tell at a glance
                                                    which of the two pricing paths produced the number (US-597).-->
                                                <th scope="row" *ngIf="carpet.bypassed">{{'admin.dealer.order.carpet_fixed_price'|translate}}</th>
                                                <th scope="row" *ngIf="!carpet.bypassed">{{'admin.dealer.order.carpet_material'|translate}}
                                                  ({{carpetAreaLabel(carpet.areaM2)}} m²)
                                                </th>
                                                <td class="text-end">{{carpetAmount(carpet, 'material') | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                                              </tr>
                                              <tr *ngIf="carpetAmount(carpet, 'shape') as shapeAmount">
                                                <th scope="row">{{'admin.dealer.order.carpet_shape'|translate}}</th>
                                                <td class="text-end">{{shapeAmount | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                                              </tr>
                                              <tr *ngIf="carpetAmount(carpet, 'finishing') as finishingAmount">
                                                <th scope="row">{{'admin.dealer.order.carpet_finishing'|translate}}
                                                  ({{carpet.perimeterM | number:'1.2-2'}} m)
                                                </th>
                                                <td class="text-end">{{finishingAmount | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                                              </tr>
                                              <tr class="fw-bold">
                                                <th scope="row">{{'admin.dealer.order.carpet_per_unit'|translate}}</th>
                                                <td class="text-end">{{carpetPerUnitTotal(carpet) | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                                              </tr>
                                              <!--shape scales with quantity exactly like material and finishing (FR-014)-->
                                              <tr class="fw-bold" *ngIf="productItem.amount > 1">
                                                <th scope="row">× {{productItem.amount}}</th>
                                                <td class="text-end">{{carpetLineTotal(carpet) | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                                              </tr>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                                </ng-container>

                                <!--    fabric condition-->
                                <div class="form-group no-margin-bottom margin-top" *ngIf="orderItem.orderItemProducts && orderItem.orderItemProducts.length>1 && j!=0 &&
                                   orderItem.orderItemProducts[0].orderItemProductFabricCollection &&
                                   orderItem.orderItemProducts[0].orderItemProductFabricCollection.fabricsCollections &&
                                   orderItem.orderItemProducts[0].orderItemProductFabricCollection.fabricsCollections.length > 0 &&
                                   productItem.orderItemProductFabricCollection &&
                                   productItem.orderItemProductFabricCollection.fabricsCollections && productItem.orderItemProductFabricCollection.fabricsCollections.length">
                                  <div class="card-align">
                                    <div class="d-flex">
                                      <label class="col-form-label no-padding-right left-pos"
                                             [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 custom-padding'">
                                        <span class="labelWithToolTip no-padding-y"></span>
                                        <!--tooltip-item-->
                                        <span class="tooltip-item ">
                                    <span class="tooltipBox"><i class="fa fa-info-circle fa-2x "
                                                                aria-hidden="true"></i></span>
                                   <span class="desc-place">
                                        <ng-container>
                                         <div>
                                         {{'admin.dealer.order.fabric_description'|translate}}
                                        </div>
                                         </ng-container>
                                    </span>
                                    </span>
                                      </label>
                                      <div  [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9 p-0': 'col-sm-9 p-0'">

                                          <div class="de-flex">
                                            <div class="col-sm-12  allowFabric no-padding-y">
                                              <input type="checkbox"
                                                     [id]="'newFabricAllow'+j+'-'+ i"
                                                     class="border-checkbox"
                                                     [name]="'newFabricAllow'+j+'-'+ i"
                                                     #newFabricAllow="ngModel"
                                                     [(ngModel)]="orderItem.orderItemProducts[j].allowFabric"
                                                     (change)="allowFabric(i,j,!orderItem.orderItemProducts[j].allowFabric)"
                                              />
                                              <label class="border-checkbox-label mb-0"
                                                     [for]="'newFabricAllow'">{{'doctrine.fabric.different_fabric'|translate}}</label>
                                            </div>
                                          </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>


                                  <!--    fabric-->
                                  <div class="form-group no-margin-bottom margin-top"
                                       *ngIf="productItem.orderItemProductFabricCollection
                                   && (productItem.orderItemProductFabricCollection.fabricsCollections && productItem.orderItemProductFabricCollection.fabricsCollections.length)
                                   && (
                                   (j==0 )|| (j!=0 && orderItem.orderItemProducts[j].allowFabric) ||
                                   (j!=0 && !(orderItem.orderItemProducts[0].orderItemProductFabricCollection &&
                                   orderItem.orderItemProducts[0].orderItemProductFabricCollection.fabricsCollections &&
                                   orderItem.orderItemProducts[0].orderItemProductFabricCollection.fabricsCollections.length > 0) ))"
                                       [ngClass]="{'two-col': productItem.orderItemProductFabricCollection.fabricCollection
                                   && !productItem.orderItemProductFabricCollection.fabric,
                                    'three-col':productItem.orderItemProductFabricCollection.fabricCollection
                                    && productItem.orderItemProductFabricCollection.fabric}">
                                    <div class="container" >
                                      <div class="row" >
                                        <label class="col-form-label no-padding-right left-pos" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3 ': 'col-sm-3 ps-0 custom-padding '">
                                          <span class="labelWithToolTip no-padding-y" >
                                            <span>{{ 'doctrine.fabric.fabric'|translate}}</span>

                                            <span class="star" *ngIf="productItem.orderItemProductFabricCollection.fabricsCollections.length">*</span></span>
                                          <!--tooltip-item-->
                                          <span class="tooltip-item">
                                        <span class="tooltipBox">
                                          <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                        </span>
                                        <span class="desc-place">
                                          <ng-container>
                                            <div>
                                               {{'admin.dealer.order.fabric_description'|translate}}
                                            </div>
                                          </ng-container>
                                      </span>
                                      </span>
                                        </label>
                                        <div  [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': ' col-sm-9 c-p'">
                                          <div
                                            [ngClass]="{'d-flex': productItem.orderItemProductFabricCollection.fabricCollection}">

                                            <div
                                              [ngClass]="{'col-sm-6 p-0': !isCustomFabric(productItem.orderItemProductFabricCollection) && productItem.orderItemProductFabricCollection.fabricCollection && !productItem.orderItemProductFabricCollection.fabric ,
                                                  'col-sm-4 ps-0':productItem.orderItemProductFabricCollection.fabricCollection
                                                  && productItem.orderItemProductFabricCollection.fabric || isCustomFabric(productItem.orderItemProductFabricCollection)}">
                                              <!--first step fabric-->
                                              <ng-select
                                                [name]="'fabricCollection'+productItem.random"
                                                #fabricCollection="ngModel"
                                                [(ngModel)]="productItem.orderItemProductFabricCollection.fabricCollection"
                                                (change)="getFabric(i,j,productItem.orderItemProductFabricCollection.fabricCollection)"
                                                bindValue="id"
                                                bindLabel="name"
                                                (search)="filterFabricCollection(i,j, $event)"
                                                [items]="productItem.orderItemProductFabricCollection.fabricsCollections"
                                                [placeholder]="'global.selectbox_placeholder'|translate"
                                                [required]="productItem.orderItemProductFabricCollection.fabricsCollections.length > 0">
                                              </ng-select>
                                              <div class="messages text-danger"
                                                   *ngIf="fabricCollection.invalid && orderItemFormChecked(i) && fabricCollection.errors?.required">
                                                {{'errors.required'|translate}}
                                              </div>
                                            </div>

                                            <div [ngClass]="{'col-sm-6 pe-0': !isCustomFabric(productItem.orderItemProductFabricCollection)  && !productItem.orderItemProductFabricCollection.fabric,
                                             'col-sm-4 ': (productItem.orderItemProductFabricCollection.fabric && !isCustomFabric(productItem.orderItemProductFabricCollection)) || isCustomFabric(productItem.orderItemProductFabricCollection)}"
                                                 *ngIf="productItem.orderItemProductFabricCollection.fabricCollection ">
                                              <!--second step fabric-->
                                              <div *ngIf="!isCustomFabric(productItem.orderItemProductFabricCollection)">
                                                <ng-select
                                                  [name]="'fabric'+productItem.random"
                                                  #fabric="ngModel"
                                                  [(ngModel)]="productItem.orderItemProductFabricCollection.fabric"
                                                  (change)="getFabricColor(i,j,productItem.orderItemProductFabricCollection.fabric)"
                                                  bindValue="id"
                                                  bindLabel="name"
                                                  (search)="filterFabric(i,j, $event)"
                                                  [placeholder]="'global.selectbox_placeholder'|translate"
                                                  [items]="productItem.orderItemProductFabricCollection.fabrics"
                                                  [required]="!isCustomFabric(productItem.orderItemProductFabricCollection)">
                                                </ng-select>
                                                <div class="messages text-danger"
                                                     *ngIf="fabric.invalid && orderItemFormChecked(i) && fabric.errors?.required">
                                                  {{'errors.required'|translate}}
                                                </div>
                                              </div>
                                              <div *ngIf="isCustomFabric(productItem.orderItemProductFabricCollection)">
                                                <input class="form-control form-control-normal"
                                                       [name]="'fabricName'+productItem.random"
                                                       #fabricName="ngModel"
                                                       type="text"
                                                       [placeholder]="'doctrine.fabric.fabric_name_placeholder'|translate"
                                                       (input)="changeFabricName(i,j,productItem.orderItemProductFabricCollection.fabricName)"
                                                       [(ngModel)]="productItem.orderItemProductFabricCollection.fabricName"
                                                       [required]="isCustomFabric(productItem.orderItemProductFabricCollection)"
                                                />
                                                <div class="messages text-danger"
                                                     *ngIf="fabricName.invalid && orderItemFormChecked(i) && fabricName.errors?.required">
                                                  {{'errors.required'|translate}}
                                                </div>
                                              </div>
                                            </div>

                                            <div
                                              [ngClass]="{'col-sm-4 pe-0':productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric}"
                                              *ngIf="!isCustomFabric(productItem.orderItemProductFabricCollection) && productItem.orderItemProductFabricCollection.fabricCollection && productItem.orderItemProductFabricCollection.fabric">
                                              <!--third step fabric-->
                                              <div>
                                                <ng-select
                                                  [name]="'fabricColor'+productItem.random"
                                                  #fabricColor="ngModel"
                                                  [(ngModel)]="productItem.orderItemProductFabricCollection.fabricColor"
                                                  bindValue="id"
                                                  bindLabel="name"
                                                  (change)="changeFabricColor(i,j,productItem.orderItemProductFabricCollection.fabricColor)"
                                                  (search)="filterFabricColor(i,j, $event)"
                                                  [placeholder]="'global.selectbox_placeholder'|translate"
                                                  [items]="productItem.orderItemProductFabricCollection.fabricColors"
                                                  [required]="!isCustomFabric(productItem.orderItemProductFabricCollection)">
                                                  <!--img for select-->
                                                  <ng-template ng-label-tmp let-item="item">
                                                    <!--<img *ngIf="item.image" [src]="absolutePath + '/' +item.image.fullPath"
                                                         class="select-img"/>-->
                                                    <span class="ms-1">
                                              {{ item.name }}
                                              </span>
                                                  </ng-template>
                                                  <ng-template ng-option-tmp let-item="item">
                                                    <!--<img *ngIf="item.image" [src]="absolutePath + '/' +item.image.fullPath"
                                                         class="select-img"/>-->
                                                    <span class="ms-1">
                                                {{ item.name }}
                                              </span>

                                                  </ng-template>

                                                </ng-select>
                                                <div class="messages text-danger"
                                                     *ngIf="fabricColor.invalid && orderItemFormChecked(i) && fabricColor.errors?.required">
                                                  {{'errors.required'|translate}}
                                                </div>
                                              </div>
                                            </div>
                                            <div [ngClass]="{'col-sm-4 pe-0':productItem.orderItemProductFabricCollection.fabricCollection}"
                                                 *ngIf="isCustomFabric(productItem.orderItemProductFabricCollection)">
                                              <div>
                                                <input class="form-control form-control-normal"
                                                       [name]="'fabricColorName'+productItem.random"
                                                       [placeholder]="'doctrine.fabric.fabric_color_placeholder'|translate"
                                                       #fabricColorName="ngModel"
                                                       type="text"
                                                       (input)="changeFabricColorName(i,j,productItem.orderItemProductFabricCollection.fabricColorName)"
                                                       [(ngModel)]="productItem.orderItemProductFabricCollection.fabricColorName"
                                                       [required]="isCustomFabric(productItem.orderItemProductFabricCollection)"
                                                />
                                                <div class="messages text-danger"
                                                     *ngIf="fabricColorName.invalid && orderItemFormChecked(i) && fabricColorName.errors?.required">
                                                  {{'errors.required'|translate}}
                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                <!--   Side fabric option   -->
                                <div *ngIf="order.orderItems[i].orderItemProducts[j].perProductOptionObj && this.order.orderItems[i].orderItemProducts[j].perProductOptionObj.option">
                                  <div class="form-group no-margin-bottom margin-top">
                                    <div class="container" >
                                      <div class="row">
                                        <label class="col-form-label no-padding-right left-pos col-sm-3">
                                        <span class="labelWithToolTip no-padding-y" >
                                        </span>
                                          <!--tooltip-item-->
                                          <span class="tooltip-item">
                                          <span class="tooltipBox">
                                            <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                          </span>
                                          <span class="desc-place">
                                            <ng-container>
                                              <div>
                                                 {{order.orderItems[i].orderItemProducts[j].perProductOptionObj && this.order.orderItems[i].orderItemProducts[j].perProductOptionObj.option.description}}
                                              </div>
                                            </ng-container>
                                          </span>
                                        </span>
                                        </label>
                                        <div class="col-sm-9 pt-1">
                                          <input type="checkbox"
                                            [id]="'productPerType'+j+'-'+ i"
                                            class="border-checkbox"
                                            [name]="'productPerType'+j+'-'+ i"
                                            #productPerType="ngModel"
                                            [(ngModel)]="orderItem.orderItemProducts[j].allowFabricSide"
                                            (change)="allowPerProductOption(i,j,orderItem.orderItemProducts[j].allowFabricSide)"
                                          >
                                          <label class="border-checkbox-label mb-0" [for]="productPerType">
                                            {{order.orderItems[i].orderItemProducts[j].perProductOptionObj.option.name}}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- Side fabric type -->
                                  </div>
                                  <div class="form-group no-margin-bottom margin-top"
                                       *ngIf="orderItem.orderItemProducts[j].allowFabricSide &&
                                          order.orderItems[i].orderItemProducts[j].perProductOptionObj.option.options.length > 0 && order.orderItems[i].orderItemProducts[j].perProductOptionObj.option.options[0].options.length > 1">
                                    <div class="container margin-top">
                                      <div class="row">
                                        <label class="col-form-label no-padding-right left-pos col-sm-3 pt-2">
                                        <span class="labelWithToolTip no-padding-y">
                                          {{this.order.orderItems[i].orderItemProducts[j].perProductOptionObj.option.options[0].name}}&nbsp;*
                                        </span>
                                        </label>
                                        <div class="col-sm-9 pt-1">
                                          <ng-select
                                            [items]="order.orderItems[i].orderItemProducts[j].perProductOptionObj.option.options[0].options"
                                            bindLabel="name"
                                            bindValue="id"
                                            [placeholder]="'global.selectbox_placeholder'|translate"
                                            (change)="onChangePerProductOption(i,j,$event)"
                                            [(ngModel)]="order.orderItems[i].orderItemProducts[j].selectedPerProductOption"
                                            [name]="'selectedPerProductOption'+j+'-'+ i"
                                            [clearable]="false"
                                            #selectedPerProductOption="ngModel"
                                            required
                                          >
                                          </ng-select>
                                          <div class="messages text-danger"
                                               *ngIf="selectedPerProductOption.invalid && orderItemFormChecked(i) && selectedPerProductOption.errors?.required">
                                            {{'errors.required'|translate}}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                                <div class="form-group no-margin-bottom " *ngIf="productItem.orderItemProductPackages">
                                  <div class="container" >
                                    <div class="row">
                                      <ng-container *ngFor="let package of productItem.orderItemProductPackages;let z=index">
                                        <label class="col-form-label no-padding-right left-pos margin-top" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3 p-0'">
                                          <div class="" *ngIf="package.packageObj">
                                            <div [ngClass]="z > 0 ? 'pt-2 mt-1' : 'mt-1'">{{package.packageObj.name}}<span
                                              *ngIf="package.packageObj.required" class="star">*</span>
                                            </div>
                                          </div>

                                        </label>
                                        <div style="padding-left: 2px !important;" class="margin-top" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9 c-p'">
                                          <div class="" *ngIf="package.packageObj">
                                            <div class="">
                                              <ng-select
                                                [ngClass]="z > 0 ? 'pt-2' : ''"
                                                [name]="'packageProductItem'+j+'-'+ i+'-'+z"
                                                #productItem="ngModel"
                                                [(ngModel)]="package.orderItemProductPackageProducts[0].product"
                                                [required]="package.packageObj.required"
                                                [placeholder]="package.packageObj.required?('global.selectbox_placeholder'|translate):''"
                                                (change)="onPackageProductChange(i,j,z,$event);findPackProduct(i,j,z,package.orderItemProductPackageProducts[0].product);getAllTotal();fillStockAmountForPackage(package.orderItemProductPackageProducts[0]);"
                                                [clearable]="true"
                                                bindValue="product.id"
                                                bindLabel="product.name"
                                                (clear)="onProductPackageClear(i, package.packageObj.packageProducts[0].product.id)"
                                                [items]="package.packageObj.packageProducts"></ng-select>
                                              <div class="messages text-danger"
                                                   *ngIf="productItem.invalid && orderItemFormChecked(i) && productItem.errors?.required">
                                                {{'errors.required'|translate}}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div  class="no-padding" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-3': 'col-sm-3'"></div>
                                        <div class="margin-top pt-2" *ngIf="(package.orderItemProductPackageProducts.length>0 && package.orderItemProductPackageProducts[0].stockAmountAlert && package.orderItemProductPackageProducts[0].stockAmountAlert.shouldShow) else emptyPackage" [ngClass]="productItem.productObj && productItem.productObj.image ? 'col-sm-9': 'col-sm-9'">
                                          <div [ngClass]="[package.orderItemProductPackageProducts[0].stockAmountAlert && package.orderItemProductPackageProducts[0].stockAmountAlert.shouldShow?package.orderItemProductPackageProducts[0].stockAmountAlert.color:'']">
                                            <div><i class="fa fa-circle"></i>&nbsp;{{package.orderItemProductPackageProducts[0].stockAmountAlert.message}}</div>
                                          </div>
                                        </div>
                                        <ng-template #emptyPackage>
                                          <div class="col-md-9 no-padding-left"></div>
                                        </ng-template>
                                      </ng-container>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <div *ngIf="productItem.productObj" class="col-md-2 col-sm-4 text-center">
                                <span *ngIf="productItem.productObj.image">
                                  <img class="product-img-thumbnail img-thumbnail img-fluid" width="150" height="50"
                                       src="{{ absolutePath + '/' + productItem.productObj.image.fullPath }}"/>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--
                      ====================================
                      # Add new Product
                      ====================================
                      -->
                      <button class="btn ripple light btn-grey margin-top" (click)="addProductItem(i)" *ngIf="lastProductsIndex">
                        <i class="fa fa-plus fa-fw"></i> {{'admin.product.show.add.product'|translate}}
                      </button>
                    </div>

                  </ng-container>
                  <!--
                      ====================================
                      # Options
                      ====================================
                      -->
                  <!-- carpet-role groups are NOT here: a rug's shape/finishing/colour belong to one
                       element, so they render under that element (carpetOptionGroupsFor). Everything
                       else keeps the article-level behaviour. -->
                  <ng-container *ngIf="articleOptionGroups(order.orderItems[i]).length > 0">
                    <div  class="card-header"><b>{{ 'doctrine.order.options'|translate }} {{ i + 1 }}</b></div>
                    <div class="margin-top bg-light text-dark">
                      <div class="card-body option">
                        <div class="container">
                          <div class="row">
                            <div class="col-md-12 col-sm-12 no-padding-left">
                              <app-option
                                *ngFor="let optionProduct of articleOptionGroups(order.orderItems[i]);let j=index"
                                [optionItems]="optionProduct"
                                [orderItemIndex]="i"
                                [parentFormChecked]="orderItemFormChecked(i)"
                                [show]="true"
                                [optionProductIndex]="optionProduct.option.id"
                                [orderItemProducts]="order.orderItems[i].orderItemProducts"
                                [lastValues]="optionProduct.lastValues"
                                (checkIsValid)="setButtonStatus($event)"
                                (orderItemProductOption)="chooseOptionForAnArticle($event)"
                              >

                              </app-option>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

            </app-card>
          </div>
          <!--
    ====================================
    # Add new article
    ====================================
    -->
          <button *ngIf="!isBackoffice || (order.user && order.user.country)"
                  class="btn btn-primary ripple light margin-bottom" type="button" (click)="addOrderItem()">
            <i class="fa fa-plus fa-fw"></i> {{'admin.product.show.add.order_item'|translate}}
          </button>
          <button *ngIf="isBackoffice && order.user && order.user.country"
                  class="btn btn-primary ripple light margin-bottom ms-1" type="button" (click)="showAddCustomRowModal()">
            <i class="fa fa-plus fa-fw"></i> {{'doctrine.order.add_custome_row'|translate}}
          </button>
          <button *ngIf="isBackoffice && order.user && order.user.country"
                  class="btn btn-primary ripple light margin-bottom ms-1" type="button" (click)="showAddDiscountModal()">
            <i class="fa fa-plus fa-fw"></i> {{'doctrine.order.add_discount'|translate}}
          </button>
          <div class="clearfix"></div>

          <!--
          ============================
          # Order custom row information template ref
          ============================
          -->
          <ng-container *ngIf="order.customRows && order.customRows.length > 0">
            <app-card [title]="'admin.dealer.order.custom_order'|translate">
              <div class="card-body">
                <div class="form-group no-margin-bottom">
                  <div class="container">
                    <div class="row">
                      <ng-container *ngFor="let customRow of order.customRows">
                        <ng-template
                          [ngTemplateOutlet]="orderCustomRowTemplateRef"
                          [ngTemplateOutletContext]="{ customRow: customRow }">
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </app-card>
          </ng-container>

          <!--
          ============================
          # Delivery options box
          ============================
          -->
          <app-card [title]="'admin.order.delivery_options'|translate"
                    *ngIf="hasRegularDelivery && (showDeliveryWeek || (showPartialOrder && (order.allowPartial != null)))">
            <div class="card-body">
              <!-- Delivery-->
              <div class="form-group no-margin-bottom" *ngIf="showDeliveryWeek">
                <div class="container">
                  <div class="">
                    <div class="d-flex row align-items-center">
                      <label class="col-3 col-form-label no-padding-right left-pos d-flex">
                        <span class="labelWithToolTip no-padding-y">
                          {{'admin.order.delivery_week_label'|translate}}
                         </span>
                        <!--tooltip-item-->
                        <span class="tooltip-item tooltip-item-date align-middle">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-picker">
                          <ng-container>
                            <div>
                           {{'admin.dealer.order.setting_furniture_delivery_week_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-9 d-flex no-padding-y">
                        <div class="border-checkbox-section d-flex">
                          <form novalidate #furnitureDelivery="ngForm">
                            <input
                              type="checkbox"
                              [name]="furnitureDelivery"
                              #furnitureDelivery="ngModel"
                              [(ngModel)]="order.allowDeliveryWeek"
                              (ngModelChange)="clearDeliveryWeek()"
                            >
                            <label class="border-checkbox-label mb-0" [for]="furnitureDelivery"> {{'admin.order.adjust_delivery_week_label'|translate}}
                            </label>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- after Delivery-->
              <div class="form-group margin-top no-margin-bottom" *ngIf="order.allowDeliveryWeek">
                <div class="container">
                  <div class="">
                    <div class="row">
                      <label class="col-3 col-form-label "></label>
                      <div class="col-sm-9 col-md-9 col-lg-9 delivery-week-datepicker">
                        <app-ngbd-datepicker-config *ngIf="getMinDeliveryWeek()"
                                                    [showWarning]="orderItemFormChecked()"
                                                    (weekSelected)="onDeliveryWeekSelected($event)"
                                                    [lastValue]="order.deliveryWeek"
                                                    [minDeliveryWeek]="getMinDeliveryWeek()">
                        </app-ngbd-datepicker-config>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!--Allow partial orders-->
              <div class="form-group no-margin-bottom" *ngIf="showPartialOrder && (order.allowPartial != null)">
                <div class="container">
                  <div class="">
                    <div class="row">
                      <label class="col-3 col-form-label no-padding-right left-pos d-flex no-padding-y">
                        <span class="labelWithToolTip">
                          {{'doctrine.order.allow_partial_order_label' | translate}}
                         </span>
                        <!--tooltip-item-->
                        <span class="tooltip-item align-middle tooltip-item-date ">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place">
                          <ng-container>
                            <div>
                           {{'doctrine.order.allow_partial_order_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-9 d-flex">
                        <form class="form-inline w-100">
                          <div class="form-group no-margin-bottom">
                            <div class="input-group">
                              <ng-select [items]="allowItems"
                                         bindLabel="label"
                                         [addTag]="false"
                                         [hideSelected]="true"
                                         [clearable]="false"
                                         name="isAllowedPartialPaid"
                                         [(ngModel)]="isAllowedPartialPaid"
                                         (change)="setPartialPaid(e)"
                                         class="w-100">
                              </ng-select>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </app-card>

          <!--
          ============================
          # secondary delivery options box
          ============================
          -->
          <app-card [title]="'admin.order.customer_delivery_options'|translate"
                    *ngIf="hasDeliveryAt">
            <div class="card-body">
              <!-- Delivery-->
              <div class="form-group no-margin-bottom" *ngIf="showDeliveryWeek">
                <div class="container">
                  <div class="">
                    <div class="d-flex row align-items-center">
                      <label class="col-3 col-form-label no-padding-right left-pos d-flex">
                        <span class="labelWithToolTip no-padding-y">
                          {{'admin.order.delivery_week_label'|translate}}
                         </span>
                        <!--tooltip-item-->
                        <span class="tooltip-item tooltip-item-date align-middle">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-picker">
                          <ng-container>
                            <div>
                           {{'admin.dealer.order.setting_furniture_delivery_week_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-9 d-flex no-padding-y">
                        <div class="border-checkbox-section d-flex">
                          <form novalidate #secondaryDelivery="ngForm">
                            <input
                              type="checkbox"
                              [name]="secondaryDelivery"
                              #composedDelivery="ngModel"
                              [(ngModel)]="order.allowSecondaryDeliveryWeek"
                              (ngModelChange)="clearSecondaryDeliveryWeek()"
                            >
                            <label class="border-checkbox-label mb-0" [for]="secondaryDelivery"> {{'admin.order.adjust_delivery_week_label'|translate}}
                            </label>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- after Delivery-->
              <div class="form-group margin-top no-margin-bottom" *ngIf="order.allowSecondaryDeliveryWeek">
                <div class="container">
                  <div class="">
                    <div class="row">
                      <label class="col-3 col-form-label "></label>
                      <div class="col-sm-9 col-md-9 col-lg-9 delivery-week-datepicker">
                        <app-ngbd-datepicker-config [showWarning]="orderItemFormChecked()"
                                                    (weekSelected)="onSecondaryDeliveryWeekSelected($event)"
                                                    [lastValue]="order.secondaryDeliveryWeek"
                                                    [minDeliveryWeek]="4">
                        </app-ngbd-datepicker-config>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Delivery at-->
              <div class="form-group no-margin-bottom">
                <div class="container">
                  <div class="">
                    <div class="d-flex row align-items-center">
                      <label class="col-3 col-form-label no-padding-right left-pos d-flex">
                        <span class="labelWithToolTip no-padding-y">
                          {{'admin.order.delivery_at'|translate}}
                          <span class="star">*</span>
                         </span>
                        <!--tooltip-item-->
                        <span class="tooltip-item tooltip-item-date align-middle">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-picker">
                          <ng-container>
                            <div>
                           {{'admin.dealer.order.setting_secondary_delivery_at_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-3 no-padding-y">
                        <ng-select class=" w-100 ng-select" #deliveryAt="ngModel" name="deliveryAt" [items]="deliveryAtOptions" (change)="checkDeliveryAtDealer()" bindValue="value" bindLabel="label" [(ngModel)]="order.secondaryDeliveryAt"
                                   [clearable]="false" required [searchable]="false"></ng-select>
                        <div class="messages text-danger"
                             *ngIf="deliveryAt.invalid && orderItemFormChecked() && deliveryAt.errors?.required">
                          {{'errors.required'|translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </app-card>
        </div>



        <!--
  ====================================
  # Order Detail (Reference & Delivery) [start]
  ====================================
  -->
        <div class="col-md-12 col-sm-12 isShow" [ngClass]="[!isTabletLandscape ? 'col-lg-6' : '']" *ngIf="isShow">
          <app-card [title]="isQuote ? ('admin.quote.detail'|translate ) : ('admin.order.detail'|translate)">
            <!--   reference-->
            <div class="card-body">
              <div class="form-group no-margin-bottom">
                <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                    <span class="labelWithToolTip ">{{'doctrine.order.reference'|translate}}<span
                      class="star">*</span></span>
                      <!--tooltip-item-->
                        <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.reference_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                      </label>
                      <div class="col-sm-7">
                        <p class="field-place col-form-label">{{ order.reference }}</p>
                      </div>
                    </div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="form-group no-margin-bottom">
                <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                    <span class="labelWithToolTip ">{{'admin.order.remark'|translate}}</span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.remark_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                    </label>
                    <div class="col-sm-7">
                      <p class="field-place col-form-label">{{ order.remark }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--deliveryWeek-->
            <div class="card-body" *ngIf="checkDeliveryWeek(order) && order.expectedDeliveryWeek">
            <div class="form-group no-margin-bottom">
              <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right  left-pos">
                      <span class="labelWithToolTip">  {{'doctrine.order.expected_delivery'|translate}}</span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.delivery_week_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>

                    </label>
                    <div class="col-sm-7">
                      <ng-container *ngIf="order.expectedDeliveryWeek">
                        <p class="field-place col-form-label">{{order.expectedDeliveryWeek|WeekDateFormat}}</p>
                      </ng-container>
  <!--                    We don't show this template again when expected delivery week not set-->
  <!--                    <ng-template #noDeliveryWeek>-->
  <!--                      <p class="field-place col-form-label">{{'global.as_soon_as_possible'|translate}}</p>-->
  <!--                    </ng-template>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--requested delivery week-->
            <div class="card-body" *ngIf="order.deliveryWeek && isQuote">
              <div class="form-group no-margin-bottom">
                <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right  left-pos">
                      <span class="labelWithToolTip">  {{'doctrine.order.requested_delivery_week'|translate}}</span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.delivery_week_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>

                    </label>
                    <div class="col-sm-7">
                      <ng-container>
                        <p class="field-place col-form-label">{{ order.deliveryWeek|  WeekDateFormat}}</p>
                      </ng-container>
                      <!--                    We don't show this template again when expected delivery week not set-->
                      <!--                    <ng-template #noDeliveryWeek>-->
                      <!--                      <p class="field-place col-form-label">{{'global.as_soon_as_possible'|translate}}</p>-->
                      <!--                    </ng-template>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--StockDeliveryWeek-->
            <div class="card-body" *ngIf="order.stockDeliveryWeek">
            <div class="form-group no-margin-bottom" *ngIf="order.stockDeliveryWeek">
              <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                      <span class="labelWithToolTip">  {{'doctrine.order.expected_delivery'|translate}}</span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.stock_delivery.stock_product_deliveryweek_tooltip'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                    </label>
                    <div class="col-sm-6">
                      <p class="field-place col-form-label">{{order.expectedDeliveryWeek ? (order.expectedDeliveryWeek|WeekDateFormat) : ''}}</p>
                    </div>
                  </div>
              </div>
            </div>
            </div>
            <!--allowPartial-->
            <div class="card-body" *ngIf="checkAllowPartialOrder(order) && order.allowPartial">
            <div class="form-group no-margin-bottom" *ngIf="checkAllowPartialOrder(order) && order.allowPartial">
              <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                    <span class="labelWithToolTip">{{'doctrine.user.allow_partial_order_description'|translate}}
                      </span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.reference_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                    </label>
                    <div class="col-sm-7">
                      <p
                        class="field-place col-form-label">{{this.getOrderAllowStatusTranslation(order.allowPartial)}}</p>
                    </div>
                  </div>
              </div>
            </div>
            </div>
          </app-card>

          <!--
          ====================================
          # Just for converted orders we display a text only to explain that how get more details
          ====================================
          -->
          <app-card *ngIf="order.isConverted" headerClass="convert-order-text"
                    [title]="'admin.order.converted_order_help_message_details' | translate">
          </app-card>

          <!--
          ====================================
          # Order Items (Articles) - [start]
          ====================================
          -->
          <app-card *ngFor="let orderItem of order.orderItems;let i=index;"
                    [title]="'admin.order.article'|translate:{'number': i+1}">


            <!-- Details for collection
             ------------------------->
            <div class="card-body">
            <div class="form-group no-margin-bottom">
              <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                    <span class="labelWithToolTip"> {{'doctrine.attributes.collection'|translate}}
                      <span class="star">*</span></span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                           {{'admin.dealer.order.collection_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>

                    </label>
                    <div class="col-sm-7 ">
                      <p class="field-place col-form-label">

                        {{ orderItem.collection.name}}
                      </p>
                    </div>
                  </div>
              </div>
            </div>
            </div>
            <!-- Details for model
             --------------------->
            <div class="card-body">
            <div class="form-group no-margin-bottom">
              <div class="container">
                  <div class="row">
                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                      <span class="labelWithToolTip">  {{'doctrine.attributes.model'|translate}} <span class="star">*</span></span>
                      <!--tooltip-item-->
                      <span class="tooltip-item">
                           <span class="tooltipBox">
                             <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                           </span>
                          <span class="desc-place desc-place-view">
                          <ng-container>
                            <div>
                            {{'admin.dealer.order.model_description'|translate}}
                            </div>
                          </ng-container>
                      </span>
                         </span>
                    </label>
                    <div class="col-sm-6">
                      <p class="field-place col-form-label">
                        <span> {{ orderItem.model.name}}</span>
  <!--                  {{orderItem|json}}-->
                        <span *ngIf="orderItem.style!==null">, {{ orderItem.style.name}}</span>

                      </p>
                    </div>
                  </div>
              </div>
            </div>
            </div>
            <!--
            ======================================================
            # Products (Products/Elements of an Article) - [start]
            ======================================================
            -->
            <ng-container *ngFor="let productItem of orderItem.orderItemProducts;let j=index;">
              <div class="margin-top margin-bottom container">
                <div class="row">
                  <div class="col-lg-6 no-padding-left no-padding-right card-header ">
                    <strong class="box-title">{{'admin.order.element'|translate}} {{orderItemCount(j)}}</strong>
                  </div>
                </div>
              </div>
              <div class="" *ngIf="productItem.productObj">
                <!--insert product col-->
                <div class="bg-light text-dark no-margin-bottom">
                  <div class="card-body fabrics mb-2">
                    <div class="container">
                      <!--form with  with img  -->
                      <div class="row">
                        <!--form-box-->
                        <div class=" no-padding-left col-md-10 col-sm-8">
                          <div class="form-group no-margin-bottom">
                            <div class="container">
                              <div class="row">
                                <label class=" col-sm-6 col-form-label no-padding-left no-padding-right left-pos ps-0 ">
                                   <span class="labelWithToolTip">
                                        {{'doctrine.attributes.product'|translate}} <span class="star">*</span>
                                   </span>
                                  <!--tooltip-item-->
                                  <span class="tooltip-item" *ngIf="productItem.productObj.description">
                                   <span class="tooltipBox">
                                     <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                   </span>
                                  <span class="desc-place desc-place-view-option">
                                  <ng-container>
                                    <div>
                                     {{productItem.productObj.description}}
                                    </div>
                                  </ng-container>
                              </span>
                                 </span>

                                </label>
                                <div class="col-sm-6" >
                                  <div class="d-flex">
                                    <div class="pe-1">
                                      <p class="field-place col-form-label">
                                        {{ productItem.amount}}
                                      </p>
                                    </div>
                                    <div class="col-sm-10 ps-0">
                                      <p class="field-place col-form-label">
                                      <span>
                                          {{ productItem.productObj.name }}
                                      </span>
                                      </p>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Fabric -------------------------------------------------------->
                          <div class="form-group no-margin-bottom" *ngIf="productItem.orderItemProductFabricCollections.length !== 0 && checkHasFabric(productItem.orderItemProductFabricCollections[0])">
                            <div class="container">
                              <div class="row">
                                <label class="col-form-label col-sm-6 ps-0 no-padding-left left-pos no-padding-right">
                                   <span class="labelWithToolTip">
                                         {{'doctrine.attributes.fabric'|translate}}
                                     <span class="star"> *</span>
                                   </span>
                                  <!--tooltip-item-->
                                  <span class="tooltip-item">
                                   <span class="tooltipBox">
                                     <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                   </span>
                                  <span class="desc-place desc-place-view-option">
                                  <ng-container>
                                    <div>
                                        {{'admin.dealer.order.fabric_description'|translate}}
                                    </div>
                                  </ng-container>
                              </span>
                                 </span>

                                </label>
                                <!-- Fabric collection, Fabric, Fabric color (with image)
                                 -------------------------------------------------------->
                                <div class="col-sm-6 ">
                                  <div class="" *ngFor="let fabricItem of productItem.orderItemProductFabricCollections">
                                    <!--    <div class="col-sm-2">
                                          <img width="20" height="20"
                                               [src]="baseURL+'/uploads/private/FabricColor_image/fabric_default_image.jpg'"
                                               alt=""/>
                                        </div>-->
                                    <div class=" " *ngIf="fabricItem.fabricCollection">
                                      <p *ngIf="fabricItem.fabricCollection.isCustom" class="field-place col-form-label">
                                        {{ (fabricItem.fabricCollection.name) + ', ' + (fabricItem.fabricName) + ', ' + (fabricItem.fabricColorName) }}
                                      </p>
                                      <p *ngIf="!fabricItem.fabricCollection.isCustom" class="field-place col-form-label">
                                        {{ (fabricItem.fabricCollection.name) + ', ' + (fabricItem.fabric.name) + ', ' + (fabricItem.fabricColor.name) }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Product packages ----------------------------------------------->
                          <div *ngIf="productItem.orderItemProductPackages.length !== 0">
                            <div class="container">
                              <div class="row" *ngFor="let packageProduct of productItem.orderItemProductPackages">
                                <label  class="col-form-label col-sm-6 no-padding-left no-padding-right left-pos form-group ps-0 " *ngIf="packageProduct.orderItemProductPackageProducts[0] && packageProduct.orderItemProductPackageProducts[0].productObj">
                                     <span class="labelWithToolTip">
                                       {{packageProduct.packageObj.name}}
                                     </span>
                                  <!--tooltip-item-->
                                  <span class="tooltip-item" *ngIf="packageProduct.orderItemProductPackageProducts[0]">
                                     <span class="tooltipBox">
                                       <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                     </span>
                                      <span class="desc-place col-form-label">
                                        <ng-container>
                                          <div *ngIf="packageProduct.orderItemProductPackageProducts[0] &&
                                           packageProduct.orderItemProductPackageProducts[0].productObj &&
                                            packageProduct.orderItemProductPackageProducts[0].productObj.product">
                                              {{packageProduct.orderItemProductPackageProducts[0].productObj.product.description}}
                                          </div>
                                        </ng-container>
                                      </span>
                                   </span>
                                </label>
                                <div class="col-sm-6 " *ngIf="packageProduct.orderItemProductPackageProducts[0] && packageProduct.orderItemProductPackageProducts[0].productObj && packageProduct.orderItemProductPackageProducts[0].productObj.product">
                                  <div class="">
                                    <div class="">
                                      <p class="field-place col-form-label">
                                        {{packageProduct.orderItemProductPackageProducts[0].productObj.product.name}}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- End of product packages ----------------------------------------------->

                        </div>
                        <!-- Product image ---------------->
                        <div *ngIf="productItem.productObj" class="col-md-2 col-sm-4 text-center">
                            <span *ngIf="productItem.productObj.image">
                              <ng-container *ngIf="productItem.productObj.image;else doesntHaveFileManagers">
                                   <img class="img-fluid" width="150" height="50"
                                        src="{{ absolutePath + '/' + productItem.productObj.image.fullPath }}"/>
                              </ng-container>
                              <ng-template #doesntHaveFileManagers>
                                      <img class="img-fluid" width="150" height="50"
                                           src="{{ absolutePath + '/' + productItem.productObj.image.fullPath }}"/>
                              </ng-template>
                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </ng-container>
            <!--=======================# Options===========================-->
            <!--  <div class="container" style="border:solid blue">-->
            <!--start-->
            <ng-container *ngIf="options[i] && options[i].length>0">
              <div class="margin-top margin-bottom card-header"><b>{{ 'doctrine.order.options'|translate }} {{i + 1}}</b></div>
              <div class=" bg-light text-dark">
                <div class="card-body option view-option">
                  <div class="container">
                  <div class="row">
                    <div class="col-md-12 col-sm-12">

                            <ng-container *ngFor="let item of options[i];let index=index;">
                              <!-- first level-->

                              <div class="d-flex">
                                <label class="col-sm-5 col-form-label no-padding-right left-pos">
                                  <span class="labelWithToolTip">{{item.parent}}</span>
                                  <!--tooltip-item-->
                                  <span class="tooltip-item" *ngIf="item.hasOwnProperty('parent_description')">
                                                  <span class="tooltipBox">
                                                    <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                                   </span>
                                                  <span class="desc-place desk-place-view-option">
                                                  <ng-container>
                                                    <div>
                                                  {{item.parent_description}}
                                                    </div>
                                                  </ng-container>
                                              </span>
                                                </span>
                                </label>
                                <div class="col-sm-6 ">
                                  <p class="field-place col-form-label">
                                                <span>
                                                   {{item.current}}
                                                </span>
                                    <!--Option Type-->
                                    <ng-container *ngIf="item.type=='Option' && item.hasOwnProperty('children')">
                                      <ng-container *ngFor="let childrenFirstLevel Of item.children">
                                        <span>,&nbsp;{{childrenFirstLevel.current}}</span>
                                      </ng-container>
                                    </ng-container>
                                  </p>
                                </div>
                              </div>

                              <!-- other level fabric-->
                              <ng-container *ngIf="item.type=='Fabric'">
                                <div class="d-flex">
                                  <label class="col-sm-5 col-form-label no-padding-right left-pos">
                                                  <span class="labelWithToolTip"
                                                        [ngStyle]="{'text-indent.px': '15' }">{{'doctrine.attributes.fabric'|translate}}</span>

                                  </label>
                                  <div class="col-sm-6">
                                    <p class="field-place col-form-label">
                                      <!--   <ng-container *ngIf="item.hasOwnProperty('fabricColorImage')">
                                           <img class="me-2" width="20" height="20"
                                                [src]="baseURL+'/'+item.fabricColorImage"
                                                alt=""/>
                                         </ng-container>-->
                                      <span>{{item.fabricCollection}}</span>
                                      <span>,&nbsp;{{item.fabric}}</span>
                                      <span>,&nbsp;{{item.fabricColor}}</span>

                                    </p>
                                  </div>
                                </div>
                              </ng-container>
                              <!-- other level option-->
                              <ng-container *ngIf="item.type=='Option'&& item.hasOwnProperty('children') ">
                                <ng-container *ngFor="let children Of item.children">
                                  <ng-container *ngIf="children.type=='Fabric'">
                                    <div class="d-flex">
                                      <label class="col-sm-5 col-form-label no-padding-right left-pos">
                                                      <span class="labelWithToolTip"
                                                            [ngStyle]="{'text-indent.px': '15' }">{{'doctrine.attributes.fabric'|translate}}</span>
                                      </label>
                                      <div class="col-sm-6">
                                        <p class="field-place col-form-label">
                                          <!--        <ng-container *ngIf="children.hasOwnProperty('fabricColorImage')">
                                                    <img width="20" height="20" class="me-2"
                                                         [src]="baseURL+'/'+children.fabricColorImage"
                                                         alt=""/>
                                                  </ng-container>-->
                                          <span>{{children.fabricCollection}}</span>
                                          <span>,&nbsp;{{children.fabric}}</span>
                                          <span>,&nbsp;{{children.fabricColor}}</span>

                                        </p>
                                      </div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                              <!--other level select-->
                              <ng-container *ngIf="item.type=='Select' && item.hasOwnProperty('children')">
                                <ng-container *ngFor="let selectChild of item.children;let s=index">
                                  <div class="d-flex">
                                    <label class="col-sm-5 col-form-label no-padding-right left-pos">
                                                    <span class="labelWithToolTip"
                                                          [ngStyle]="{'text-indent.px': '15' }">{{selectChild.parent}}</span>
                                    </label>
                                    <div class="col-sm-6">
                                      <p class="field-place col-form-label">
                                        <span>{{selectChild.current}}</span>
                                        <!-- select Option-->
                                        <ng-container
                                          *ngIf="selectChild.type=='Option' && selectChild.hasOwnProperty('children')">
                                          <ng-container *ngFor="let selectOptionChild Of selectChild.children">
                                            <span>,&nbsp;{{selectOptionChild.current}}</span>
                                          </ng-container>
                                        </ng-container>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- select fabric-->
                                  <ng-container *ngIf="selectChild.type=='Fabric'">
                                    <div class="d-flex">
                                      <label class="col-sm-5 col-form-label no-padding-right left-pos">
                                                      <span class="labelWithToolTip"
                                                            [ngStyle]="{'text-indent.px': '30' }">{{'doctrine.attributes.fabric'|translate}}</span>

                                      </label>
                                      <div class="col-sm-6">
                                        <p class="field-place col-form-label">

                                          <!--        <ng-container *ngIf="selectChild.hasOwnProperty('fabricColorImage')">
                                                    <img width="20" height="20" class="me-2"
                                                         [src]="baseURL+'/'+selectChild.fabricColorImage"
                                                         alt=""/>
                                                  </ng-container>-->

                                          <span>{{selectChild.fabricCollection}}</span>
                                          <span>,&nbsp;{{selectChild.fabric}}</span>
                                          <span>,&nbsp;{{selectChild.fabricColor}}</span>

                                        </p>
                                      </div>
                                    </div>

                                  </ng-container>
                                  <!-- select select-->
                                  <ng-container
                                    *ngIf="selectChild.type=='Select' && selectChild.hasOwnProperty('children')">
                                    <ng-container *ngFor="let selectSelectChild Of selectChild.children">
                                      <div class="d-flex">
                                        <label class="col-sm-5 col-form-label no-padding-right left-pos">
                                                      <span class="labelWithToolTip"
                                                            [ngStyle]="{'text-indent.px': '30' }">{{'doctrine.attributes.fabric'|translate}}</span>
                                          <!--tooltip-item-->
                                          <span class="tooltip-item">
                                                  <span class="tooltipBox">
                                                    <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                                   </span>
                                                  <span class="desc-place desk-place-view-option">
                                                  <ng-container>
                                                    <div>
                                                    Seating comfort Information
                                                    </div>
                                                  </ng-container>
                                              </span>
                                                </span>
                                        </label>
                                        <div class="col-sm-6">
                                          <p class="field-place col-form-label">
                                            <span>{{selectSelectChild.current}}</span>
                                          </p>
                                        </div>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                  <!--end-->
                                </ng-container>
                                <!--select have child end-->
                              </ng-container>
                              <!--allItemFor-->
                            </ng-container>

                    </div>
                  </div>
                  </div>
                </div>
              </div>

            </ng-container>
            <!--end-->

          </app-card>


          <!--
          ============================
          # Order custom row information template ref
          ============================
          -->
          <ng-container *ngIf="order.customRows && order.customRows.length > 0">
            <app-card [title]="'admin.dealer.order.custom_order'|translate">
              <div class="card-body">
                <div class="form-group no-margin-bottom">
                  <div class="container">
                    <div class="row">
                      <ng-container *ngFor="let customRow of order.customRows">
                        <ng-template
                          [ngTemplateOutlet]="orderCustomRowTemplateRef"
                          [ngTemplateOutletContext]="{ customRow: customRow }">
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </app-card>
          </ng-container>

          <app-card *ngIf="order.customerDeliveryAddress?.fullName || order.dealerDeliveryAddress?.companyName" [title]="'admin.backoffice.order.delivery_information'|translate">
            <div class="card-body">
              <div class="container">
                <div class="row">
                  <div class="col-md-5 infobox">
                    <p>{{'doctrine.user.name'|translate}}</p>
                    <p>{{'doctrine.user.address'|translate}}</p>
                    <p>{{'doctrine.user.zipCode'|translate}}</p>
                    <p>{{'doctrine.user.city'|translate}}</p>
                    <p>{{'doctrine.user.country'|translate}}</p>
                    <p>{{'doctrine.user.phone'|translate}}</p>
                    <p>{{'doctrine.user.email'|translate}}</p>
                  </div>
                  <div *ngIf="order.customerDeliveryAddress" class="col-md-7 infobox">
                    <p>{{order.customerDeliveryAddress.fullName}}</p>
                    <p>{{order.customerDeliveryAddress.street + ' ' + order.customerDeliveryAddress.houseNumber }}</p>
                    <p>{{order.customerDeliveryAddress.zipCode}}</p>
                    <p>{{order.customerDeliveryAddress.city}}</p>
                    <p>{{order.customerDeliveryAddress.country}}</p>
                    <p>{{order.customerDeliveryAddress.phoneNumber}}</p>
                    <p>{{order.customerDeliveryAddress.email}}</p>
                  </div>
                  <div *ngIf="!order.customerDeliveryAddress" class="col-md-7 infobox">
                    <p>{{order.dealerDeliveryAddress.companyName}}</p>
                    <p>{{order.dealerDeliveryAddress.address}}</p>
                    <p>{{order.dealerDeliveryAddress.postalCode}}</p>
                    <p>{{order.dealerDeliveryAddress.city}}</p>
                    <p>{{order.dealerDeliveryAddress.country.name}}</p>
                    <p>{{order.dealerDeliveryAddress.phone}}</p>
                    <p>{{order.dealerDeliveryAddress.email}}</p>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </div>




        <!--
        ====================================
        # Summary box (right part)
        ====================================
        -->
        <div class="col-md-12 col-sm-12" [ngClass]="[!isTabletLandscape ? 'col-lg-6' : '']">
          <div id="summary_box">
            <app-card [title]="'admin.order.summary.title'|translate">
              <div>
                <div class="form-radio pt-2 d-flex" *ngIf="!isRegularUser && !auth.isDealerUser()">
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" name="radio" [value]="true" [(ngModel)]="priceItem"
                             (change)="getDealerPrice(true)">
                      <i class="helper"></i>{{'doctrine.product.customer_price'|translate}}
                    </label>
                  </div>
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" name="radio" [value]="false" [(ngModel)]="priceItem"
                             (change)="getDealerPrice(false)">
                      <i class="helper"></i>{{'doctrine.product.dealer_price'|translate}}
                    </label>
                  </div>
                </div>
              </div>
            <div class="table-responsive">
              <div class="scroll-table">
              <table class="table m-0" >
                <thead>
                <tr>
                  <th>{{'doctrine.attributes.articels'|translate}}</th>
                  <th>{{'doctrine.product.amount'|translate}} </th>
                  <th> {{'admin.order.price'|translate}} </th>
                  <th>{{'admin.order.total'|translate}}</th>
                </tr>
                </thead>
                <!-- start TEMPLATE shared with confirm box -->
                <ng-template #orderTemplateRef let-order="order">
                <tbody>
                <!--Order Items-->
                <ng-container *ngFor="let orderItem of order.orderItems; let z = index;">
                  <ng-container *ngFor="let orderItemProduct of orderItem.orderItemProducts;let m=index">
                    <tr *ngIf="orderItem.model">
                      <td class="no-padding">
                        <p class="py-1 m-0">
                          {{orderItem.modelObj ? orderItem.modelObj.name : ''}}
                          {{orderItem.styleObj ? orderItem.styleObj.name : ''}}
                          {{orderItemProduct.productObj ? orderItemProduct.productObj.name : ''}}
                        </p>
                      </td>
                      <td class="no-padding">
                        <p class="py-1 m-0" *ngIf="orderItemProduct.productObj">{{ orderItemProduct.cost.amount }}</p>
                      </td>
                      <td class="no-padding">
                        <!-- a rug's product row is the MATERIAL amount only; Shape and
                             Finishing price themselves on their own rows below (D7/D8) -->
                        <p class="py-1 m-0">{{ summaryUnitPrice(orderItemProduct) | CustomCurrency }}</p>
                      </td>
                      <td class="no-padding">
                        <p class="py-1 m-0">
                          {{ summaryTotalPrice(orderItemProduct) | CustomCurrency }}</p>
                      </td>
                    </tr>
                    <!-- start Package Items rows -->
                    <tr *ngFor="let packageItem of orderItemProduct.orderItemProductPackages;let z=index">
                      <td class="no-padding" *ngIf="packageItem.orderItemProductPackageProducts.length > 0 && packageItem.orderItemProductPackageProducts[0].product && packageItem.packageObj && packageItem.orderItemProductPackageProducts[0].productObj" style="text-indent: 10px;"><p class="py-1 m-0">{{packageItem.packageObj.name}}:&nbsp;{{packageItem.orderItemProductPackageProducts[0].productObj.product.name}}</p>
                      </td>
                      <td class="no-padding" *ngIf="packageItem.orderItemProductPackageProducts.length > 0 && packageItem.orderItemProductPackageProducts[0].product && packageItem.packageObj && packageItem.orderItemProductPackageProducts[0].productObj">
                        <p class="py-1 m-0">{{ packageItem.orderItemProductPackageProducts[0].cost.amount?packageItem.orderItemProductPackageProducts[0].cost.amount:'' }}</p>
                      </td>
                      <td class="no-padding" *ngIf="packageItem.orderItemProductPackageProducts.length > 0 && packageItem.orderItemProductPackageProducts[0].product && packageItem.packageObj && packageItem.orderItemProductPackageProducts[0].productObj">
                        <p class="py-1 m-0">{{(customerPrice ? packageItem.orderItemProductPackageProducts[0].cost.customerPrice : packageItem.orderItemProductPackageProducts[0].cost.dealerPrice) | CustomCurrency }}</p>
                      </td>
                      <td class="no-padding" *ngIf="packageItem.orderItemProductPackageProducts.length > 0 && packageItem.orderItemProductPackageProducts[0].product && packageItem.packageObj && packageItem.orderItemProductPackageProducts[0].productObj">
                        <p class="py-1 m-0">{{ (customerPrice ? packageItem.orderItemProductPackageProducts[0].totalCost.totalCustomerPrice : packageItem.orderItemProductPackageProducts[0].totalCost.totalDealerPrice) | CustomCurrency }}</p>
                      </td>
                    </tr>
                    <!-- end Package Items rows -->
                    <!-- start fabric Items rows -->
                    <tr>
                      <td class="no-padding" *ngIf="orderItem.orderItemProducts[m].orderItemProductFabricCollection && orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollection" style="text-indent: 10px;">
                        <p class="py-1 m-0">
                          {{ 'doctrine.fabric.fabric'|translate}}:&nbsp;{{(orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollectionObj) ? orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollectionObj.name + ', ' : ''}}
                          <span *ngIf="!isCustomFabric(orderItem.orderItemProducts[m].orderItemProductFabricCollection) && orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricObj">{{orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricObj.name + ', '}}{{(orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricColorObj) ? orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricColorObj.name : '' }}</span>
                          <span *ngIf="isCustomFabric(orderItem.orderItemProducts[m].orderItemProductFabricCollection) && orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollectionObj && orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollectionObj.fabricName">{{orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollectionObj.fabricName + ', '}}{{orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollectionObj.fabricColorName }}</span>
                        </p>
                      </td>
                      <td class="no-padding" *ngIf="orderItemProduct.orderItemProductFabricCollection && orderItemProduct.orderItemProductFabricCollection.fabricCollection && orderItemProduct.orderItemProductFabricCollection.cost">
                        <p class="py-1 m-0">{{orderItemProduct.orderItemProductFabricCollection.cost.amount > 0 ? orderItemProduct.orderItemProductFabricCollection.cost.amount : ''}}</p>
                      </td>
                      <td class="no-padding" *ngIf="orderItemProduct.orderItemProductFabricCollection && orderItemProduct.orderItemProductFabricCollection.fabricCollection">
                        <p class="py-1 m-0">{{(customerPrice ? orderItem.orderItemProducts[m].orderItemProductFabricCollection.cost.customerPrice : orderItem.orderItemProducts[m].orderItemProductFabricCollection.cost.dealerPrice) | CustomCurrency }}</p>
                      </td>
                      <td class="no-padding" *ngIf="orderItem.orderItemProducts[m].orderItemProductFabricCollection && orderItem.orderItemProducts[m].orderItemProductFabricCollection.fabricCollection">
                        <p class="py-1 m-0">{{(customerPrice ? orderItem.orderItemProducts[m].orderItemProductFabricCollection.totalCost.totalCustomerPrice : orderItem.orderItemProducts[m].orderItemProductFabricCollection.totalCost.totalDealerPrice) | CustomCurrency }}</p>
                      </td>
                    </tr>
                    <!-- end fabric Items rows -->
                    <!-- rug line: size/shape/finishing/colour render as ordinary summaryOptions
                         rows here too (D7/D8) — same rows a sofa's options use, built in
                         applyCarpetCost() so their prices always match the per-line price box. -->
                    <tr app-summary-box-option *ngFor="let summaryOption of orderItemProduct.summaryOptions"
                        [summaryOption]="summaryOption" [customerPrice]="customerPrice" [showPrice]="isCalculatable(orderItemProduct, summaryOption)" class="padding"
                    >

                    </tr>
                    <tr class="divider" *ngIf="orderItem.orderItemProducts.length !== m+1"><td colspan="4" class="line-product" ></td></tr>
                  </ng-container>
                  <tr class="divider" ><td colspan="4" class="line-article"></td></tr>
                </ng-container>

                <!--Custom Rows-->
                <ng-container *ngIf="!customerPrice || order.user?.isCustomerAccount">
                  <ng-container *ngFor="let customRow of order.customRows; let z = index;">
                    <tr *ngIf="customRow.articleName">
                      <td class="no-padding">
                        <p class="py-1 m-0">
                          {{customRow.articleName}}
                        </p>
                      </td>
                      <td class="no-padding">
                        <p class="py-1 m-0" *ngIf="customRow.amount">{{ customRow.amount }}</p>
                      </td>
                      <td class="no-padding">
                        <p class="py-1 m-0">{{ customRow.price | CustomCurrency }}</p>
                      </td>
                      <td class="no-padding">
                        <p class="py-1 m-0">
                          {{ ( customRow.price * customRow.amount ) | CustomCurrency }}</p>
                      </td>
                    </tr>
                    <tr class="divider" ><td colspan="4" class="line-article"></td></tr>
                  </ng-container>
                </ng-container>


                <ng-container *ngIf="!customerPrice && order.transportationCost > 0">
                    <tr>
                        <td><strong>{{'doctrine.order.transportation_costs'|translate}}</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                  <tr class="after-divider">
                    <td style="text-indent: 10px;"><p>{{ order.user.invoiceDealer.transportationCostDescription}}</p></td>
                    <td></td>
                    <td></td>
                    <td>{{ order.transportationCost | CustomCurrency}}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="customerPrice && order.deliveryCost > 0">
                  <tr>
                    <td><strong>{{'doctrine.order.delivery_cost'|translate}}</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="after-divider">
                    <td style="text-indent: 10px;"><p>{{'doctrine.order.delivery_cost_description'|translate}}</p></td>
                    <td></td>
                    <td></td>
                    <td>{{ order.deliveryCost | CustomCurrency}}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="!customerPrice && order.dealerDeliveryCost > 0">
                  <tr>
                    <td><strong>{{'doctrine.order.delivery_cost'|translate}}</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="after-divider">
                    <td style="text-indent: 10px;"><p>{{'doctrine.order.delivery_cost_description'|translate}}</p></td>
                    <td></td>
                    <td></td>
                    <td>{{ order.dealerDeliveryCost | CustomCurrency}}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="((!order.user?.isCustomerAccount && !customerPrice) || (order.user?.isCustomerAccount && customerPrice)) && (order.discount.amount > 0 || order.discount.percentage > 0)">
                  <tr>
                    <td><strong>{{'doctrine.order.discount'|translate}}</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="after-divider">
                    <td style="text-indent: 10px;"><p>{{ order.discount.description }}</p></td>
                    <td></td>
                    <td></td>
                    <td>-{{ (order.discount.amount > 0 ? order.discount.amount : order.discount.applied) | CustomCurrency}}</td>
                  </tr>
                </ng-container>
                <!---totalPrice-->
                <tr class="total-price">
                  <td>
                    <strong>{{(isQuote || isNewQuote) && !quoteToOrder ? ('admin.quote.summary.total.description'|translate) : ('admin.order.summary.total.description'|translate)}}</strong> {{(customerPrice ?'admin.order.summary.total.description.incvat':'admin.order.summary.total.description.exvat')|translate}}
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong data-testid="order-total">
                      {{ calculateFinalPrice(order, customerPrice, order.discount) | CustomCurrency }}
                    </strong>
                  </td>
                </tr>
                </tbody>
                </ng-template>
                <!-- end TEMPLATE shared with confirm box -->
                <ng-template
                  [ngTemplateOutlet]="orderTemplateRef"
                  [ngTemplateOutletContext]="{ order: order }">
                </ng-template>
              </table>
              </div>
              <div *ngIf="replyId" class="pt-2">
                <div class="form-radio pt-2 d-flex" *ngIf="!isRegularUser">
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" name="isService-radio" [value]="true" [(ngModel)]="isService"
                             (change)="changeOrderServiceType(true)">
                      <i class="helper"></i>{{'doctrine.order.service_order'|translate}}
                    </label>
                  </div>
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" name="isService-radio" [value]="false" [(ngModel)]="isService"
                             (change)="changeOrderServiceType(false)">
                      <i class="helper"></i>{{'doctrine.order.normal_order'|translate}}
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between" [ngClass]="replyId ? 'pt-1' : 'pt-4'">
                <div>
                  <button *ngIf="!isQuote && customerPrice;" (click)="(isShow || order.isConverted)?getGeneratedInvoiceForThisOrder():generateOrderPdf()" class="btn ripple light btn-grey" type="button">
                    {{'global.order_pdf_customer'|translate}}
                  </button>
                  <button *ngIf="!isQuote && !auth.isDealerUser() && !customerPrice;" (click)="(isShow || order.isConverted)?getGeneratedInvoiceForThisOrder():generateOrderPdf()" class="btn ripple light btn-grey" type="button">
                    {{'global.order_pdf_dealer'|translate}}
                  </button>
                  <button *ngIf="isQuote && this.customerPrice && order.remainingDays >= 0" (click)="(isShow || order.isConverted) ? getQuotePdf() : generateOrderPdf()" class="btn ripple light btn-grey" type="button">
                    <span >
                      {{'global.quote_customer_pdf'|translate}}
                    </span>
                  </button>
                  <button *ngIf="isQuote && !this.customerPrice && !auth.isDealerUser() && order.remainingDays >= 0" (click)="(isShow || order.isConverted) ? getQuotePdf() : generateOrderPdf()" class="btn ripple light btn-grey" type="button">
                    <span>
                      {{'global.quote_dealer_pdf'|translate}}
                    </span>
                  </button>
                  <button *ngIf="isShow && !isBackoffice && hasCustomFabric()" (click)="customFabricPackagingLabel()" class="btn ripple light btn-grey ms-1" type="button">
                    {{'pdf.custom_fabric_packaging_label'|translate}}
                  </button>
                </div>
                <div class="d-flex justify-content-around">
                  <button type="button" class="btn ripple light btn-grey"
                          (click)="cancelPlaceOrder()"
                          *ngIf="showCancelOrderButton() && !isQuote">
                    {{'global.cancel'|translate}}
                  </button>

                  <button type="button" class="btn btn-grey btn-outline-primary ripple light ms-1"
                          (click)="editQuote()" *ngIf="(isQuote && isShow)">
                    {{ order.remainingDays >= 0 ? ('global.edit_quote'|translate) : ('global.update_quote'|translate) }}
                  </button>
                  <button type="button" class="btn btn-grey btn-outline-primary ripple light ms-1"
                          (click)="saveQuote()" *ngIf="(!isBackoffice && ((!isShow && isQuote) || (!isShow && !isEdit))) || (order?.user?.isPrivateAccount || isQuote)">
                    {{'global.save_quote'|translate}}
                  </button>

                  <button [disabled]="placeOrderBtnIsDisable" type="button" class="btn btn-primary ripple light ms-1"
                          (click)="checkFabricCollection((isShow && !replyId)?'EditOrder':'placeOrder')"
                          *ngIf="!auth.isDealerTabletUser() && isAllowedToEdit(order) && !isQuote">
                    {{(isShow ? 'global.edit_order' : (isEdit && !replyId ? 'global.save_order' : 'global.place_order'))|translate}}
                  </button>

                  <button type="button" class="btn btn-primary ripple light ms-1"
                          (click)="checkFabricCollection('placeQuote')"
                          *ngIf="isShow && isQuote && !auth.isDealerTabletUser() && order.remainingDays >= 0">
                    {{'global.place_order'|translate}}
                  </button>
                  <button type="button" class="btn btn-primary ripple light ms-1"
                          (click)="checkFabricCollection('placeQuote')"
                          *ngIf="!isShow && isQuote && !auth.isDealerTabletUser()">
                    {{'global.place_order'|translate}}
                  </button>
                </div>
              </div>
            </div>

          </app-card>
        </div>


        <!--
  ====================================
  # Option box (right part)
  ====================================
  -->
      <ng-container  *ngIf="isShow">
        <ng-container  *ngFor="let orderItem of order.orderItems;let i=index;" >
          <!-- carpet-role groups are NOT here either: they render under their own element
               (carpetOptionGroupsFor). Instantiating app-option for them here re-emitted the
               saved leaf into selectedOptions, which rebuilt article-wide carpet rows fanned
               across every element - the behaviour the per-element design replaced - and a
               required carpet group raised "required fields" with no control on screen. -->
          <ng-container *ngIf="articleOptionGroups(order.orderItems[i]).length > 0">
            <app-option
              *ngFor="let optionProduct of articleOptionGroups(order.orderItems[i]);let j=index"
              [optionItems]="optionProduct"
              [parentFormChecked]="orderItemFormChecked(i)"
              [show]="false"
              [orderItemIndex]="i"
              [optionProductIndex]="optionProduct.option.id"
              [orderItemProducts]="order.orderItems[i].orderItemProducts"
              [lastValues]="getLastOptions(optionProduct, order.orderItems[i])"
              (checkIsValid)="setButtonStatus($event)"
              (orderItemProductOption)="chooseOptionForAnArticle($event)"
            >
            </app-option>
          </ng-container>
        </ng-container>
      </ng-container>
      </div>
    </div>

    <!-- Order confirmation-->
    <app-modal-basic #orderModal [dialogClass]="'modal-lg'" [ngClass]="[ auth.isDealerTabletUser() ? 'tablet-lg' :'' ]">
      <div class="app-modal-header">
        <h4 class="modal-title">{{ (isQuote || isNewQuote) && !quoteToOrder ? ('admin.quote.quote_confirmation.title'|translate) : ('admin.order.order_confirmation.title'|translate)}}</h4>
        <button type="button" class="close basic-close" (click)="orderModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body" id="order-confirmation">
        <p class="model-text">{{ (isQuote || isNewQuote) && !quoteToOrder ? ('admin.quote.quote_confirmation.description'|translate) : ('admin.order.order_confirmation.description'|translate)}}</p>
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                <tr>
                  <th>{{'doctrine.attributes.articels'|translate}}</th>
                  <th>{{'doctrine.product.amount'|translate}} </th>
                  <th> {{'admin.order.price'|translate}} </th>
                  <th>{{'admin.order.total'|translate}}</th>
                </tr>
                </thead>
                <ng-template
                  [ngTemplateOutlet]="orderTemplateRef"
                  [ngTemplateOutletContext]="{ order: order }">
                </ng-template>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="app-modal-footer">
        <button type="button" class="btn btn-simple me-2 ripple"
                (click)="orderModal.hide()">{{(isQuote || isNewQuote) && !quoteToOrder ? ('global.adjust_quote'|translate) : ('global.adjust_order'|translate)}}</button>
        <button class="btn btn-primary ripple light">{{(isQuote || isNewQuote) && !quoteToOrder ? ('global.confirm_quote'|translate) : ('global.confirm_order'|translate)}}</button>
      </div>
    </app-modal-basic>

    <!-- Address confirmation-->
    <app-modal-basic #addressModal [dialogClass]="'modal-lg'" [ngClass]="[ auth.isDealerTabletUser() ? 'tablet-lg' :'' ]">
      <div class="app-modal-header">
        <h4 class="modal-title">{{'admin.customer_address'|translate}}</h4>
        <button type="button" class="close basic-close" (click)="addressModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body"  id="address-confirmation">
        <p class="model-text">{{ 'admin.customer_address.description'|translate}}</p>
        <div class="container">
          <form #addressForm="ngForm" action="javascript:">
            <div *ngIf="order.secondaryDeliveryAt === 'customer' || order.user?.isCustomerAccount" class="form-row row">
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.full_name'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="addressFullName" #addressFullName="ngModel" [(ngModel)]="order.customerDeliveryAddress.fullName" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.phone_number'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="addressPhoneNumber" #addressPhoneNumber="ngModel" [(ngModel)]="order.customerDeliveryAddress.phoneNumber" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.email'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="email" class="form-control" name="addressEmail" #addressEmail="ngModel" [(ngModel)]="order.customerDeliveryAddress.email" autofocus email required>
                </div>
              </div>
              <div class="form-group col-md-6"></div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.street'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="addressStreet" #addressStreet="ngModel" [(ngModel)]="order.customerDeliveryAddress.street" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.house_number'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="addressHouseNumber" #addressHouseNumber="ngModel" [(ngModel)]="order.customerDeliveryAddress.houseNumber" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.zip_code'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="addressZipCode" #addressZipCode="ngModel" [(ngModel)]="order.customerDeliveryAddress.zipCode" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.city'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="addressCity" #addressCity="ngModel" [(ngModel)]="order.customerDeliveryAddress.city" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.country'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <ng-select *ngIf="!order.user?.isCustomerAccount" [(ngModel)]="order.customerDeliveryAddress.country" name="addressCountry"
                             #supplierItem="ngModel" [searchable]="false" [clearable]="false" required>
                    <ng-option value="Nederlands">Nederlands</ng-option>
                  </ng-select>
                  <input *ngIf="order.user?.isCustomerAccount" type="text" class="form-control" name="addressCountry" #addressCountry="ngModel" [(ngModel)]="order.customerDeliveryAddress.country" autofocus required>
                </div>
              </div>
              <div class="form-group d-flex col-md-12" *ngFor="let disclaimer of disclaimers">
                <input type="checkbox" class="border-checkbox" (change)="checkDisclaimers()" [required]="true" [name]="'disclaimer' + disclaimer.id" [id]="'disclaimer' + disclaimer.id" [ngModel]="disclaimer.checked" >
                <label class="border-checkbox-label mb-0 disclaimer-item"
                       [for]="'disclaimer' + disclaimer.id" [innerHTML]="disclaimer.content"></label>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="app-modal-footer">
        <button type="button" class="btn btn-simple me-2 ripple"
                (click)="addressModal.hide()">{{(isQuote || isNewQuote) && !quoteToOrder ? ('global.adjust_quote'|translate) : ('global.adjust_order'|translate)}}</button>
        <button type="button" (click)="confirmAddress()" [disabled]="!addressForm.valid && !disclaimersChecked" class="btn btn-primary ripple light">{{'global.confirm_address'|translate}}</button>
      </div>
    </app-modal-basic>

    <!-- POS insurance: the end customer's details.
         A SECOND modal, copied from the address confirmation above rather than the same
         modal re-pointed at another target. The one above writes straight into
         order.customerDeliveryAddress, which carries delivery and invoicing semantics: one
         wrong branch there silently turns the order into a direct-to-consumer delivery and
         re-routes the invoice e-mail. Both can be required on the same order - a Bruuts
         table and an insured sofa - so they run independently and produce two records. -->
    <app-modal-basic #posDetailsModal data-testid="pos-details-modal" [dialogClass]="'modal-lg'" [ngClass]="[ auth.isDealerTabletUser() ? 'tablet-lg' :'' ]">
      <div class="app-modal-header">
        <h4 class="modal-title" data-testid="pos-modal-title">{{'admin.pos.modal.title'|translate}}</h4>
        <button type="button" class="close basic-close" (click)="posDetailsModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body" id="pos-registration">
        <p class="model-text" data-testid="pos-modal-intro">{{'admin.pos.modal.intro'|translate}}</p>
        <div class="container">
          <form #posForm="ngForm" action="javascript:">
            <div class="form-row row">
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.full_name'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="posFullName" #posFullName="ngModel" [(ngModel)]="order.posRegistration.fullName" autofocus required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.phone_number'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="posPhoneNumber" #posPhoneNumber="ngModel" [(ngModel)]="order.posRegistration.phoneNumber" [pattern]="posPatterns.phoneNumber" required>
                  <div class="messages text-danger" data-testid="pos-phone-error" *ngIf="posPhoneNumber.touched && posPhoneNumber.errors?.pattern">
                    {{'validators.pos_registration.invalid_phone'|translate}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.email'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="email" class="form-control" name="posEmail" #posEmail="ngModel" [(ngModel)]="order.posRegistration.email" [pattern]="posPatterns.email" email required>
                  <div class="messages text-danger" data-testid="pos-email-error" *ngIf="posEmail.touched && (posEmail.errors?.pattern || posEmail.errors?.email)">
                    {{'validators.pos_registration.invalid_email'|translate}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6"></div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.street'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="posStreet" #posStreet="ngModel" [(ngModel)]="order.posRegistration.street" required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.house_number'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="posHouseNumber" #posHouseNumber="ngModel" [(ngModel)]="order.posRegistration.houseNumber" required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.zip_code'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="posZipCode" #posZipCode="ngModel" [(ngModel)]="order.posRegistration.zipCode" [pattern]="posPatterns.zipCode" required>
                  <div class="messages text-danger" data-testid="pos-postcode-error" *ngIf="posZipCode.touched && posZipCode.errors?.pattern">
                    {{'validators.pos_registration.invalid_postcode'|translate}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.city'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <input type="text" class="form-control" name="posCity" #posCity="ngModel" [(ngModel)]="order.posRegistration.city" required>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="name">
                 <span class="no-padding-y">
                    {{'doctrine.order.customer_address.country'|translate}}<span class="star">*</span>
                 </span>
                </label>
                <div>
                  <ng-select *ngIf="!order.user?.isCustomerAccount" [(ngModel)]="order.posRegistration.country" name="posCountry"
                             #posCountry="ngModel" [searchable]="false" [clearable]="false" required>
                    <!-- US-685: was a hardcoded "Nederlands"; now NL/BE/DE with translated names -->
                    <ng-option *ngFor="let code of posCountries" [value]="code">{{('doctrine.country.names.' + code)|translate}}</ng-option>
                  </ng-select>
                  <input *ngIf="order.user?.isCustomerAccount" type="text" class="form-control" name="posCountryText" #posCountryText="ngModel" [(ngModel)]="order.posRegistration.country" required>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="app-modal-footer">
        <button type="button" class="btn btn-simple me-2 ripple"
                (click)="posDetailsModal.hide()">{{(isQuote || isNewQuote) && !quoteToOrder ? ('global.adjust_quote'|translate) : ('global.adjust_order'|translate)}}</button>
        <button type="button" data-testid="pos-modal-confirm" (click)="confirmPosDetails()" [disabled]="!posForm.valid" class="btn btn-primary ripple light">{{'global.confirm'|translate}}</button>
      </div>
    </app-modal-basic>

    <app-modal-basic #pdfModal [dialogClass]="'modal-lg'">
      <div class="app-modal-header">
        <h4 class="modal-title">{{'admin.order.order_pdf.modal.title'|translate}}</h4>
        <button type="button" class="close basic-close" (click)="pdfModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body">
        <div class="col-lg-12" style="text-align: center">
          <a class="btn btn-success" href="{{pdfLink}}"
             target="_blank">{{"admin.order.order_pdf.modal.pdf_link" |translate}}</a>
        </div>
      </div>
      <div class="app-modal-footer">
        <button type="button" class="btn btn-default ripple" (click)="pdfModal.hide()">{{'global.cancel'|translate}}</button>
      </div>
    </app-modal-basic>

    <app-modal-basic #passwordModal [dialogClass]="'modal-md'" [hideOnClickOutside]="false">
      <div class="app-modal-header">
        <h4 class="modal-title">{{'admin.send_dealer_password'|translate}}</h4>
        <button type="button" class="close basic-close" (click)="checkPasswordError()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body" *ngIf="!isRegularUser">
        <form autocomplete="off" #passwordModalForm="ngForm">
          <div class="form-group form-primary">
            <label class="float-label">{{'admin.dealer_password'|translate}}</label>
            <input type="password" autocomplete="off" name="password" #password="ngModel" class="form-control" [(ngModel)]="dealerPassword"
                   required minlength="6">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="password.invalid && password.dirty && password.errors?.required">{{'errors.required'|translate}}{{password.invalid && password.dirty}}</div>
            <div class="messages text-danger"
                 *ngIf="password?.errors?.minlength">{{'validators.password.length.min'|translate}}</div>
          </div>
          <div class="app-modal-footer d-flex justify-content-between w-100">
            <button type="button" class="btn btn-simple btn-md ripple"
                    (click)="checkPasswordError()">{{'global.cancel'|translate}}</button>
            <button type="submit" class="btn btn-primary btn-md ripple light"
                    (click)="getCustomerPrice()">{{'global.get_customer_price'|translate}}</button>
          </div>
        </form>
      </div>
    </app-modal-basic>

    <a #downloadLink href="" download style="display: none"></a>

    <!--delete confirm for Article-->
    <app-modal-basic #deleteModal>
      <div class="app-modal-header">
        <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Collection'} }}</h4>
        <button type="button" class="close basic-close" (click)="deleteModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body">
        <p>{{ 'global.soft_delete_body' | translate}}?</p>
      </div>
      <div class="app-modal-footer">
        <button type="button" class="btn btn-simple ripple me-4"
                (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
        <button type="button" class="btn btn-primary ripple light"
                (click)="deleteOrderItemFirst()">{{'global.actions.delete'|translate}}</button>
      </div>
    </app-modal-basic>

    <ng-template #orderCustomRowTemplateRef let-customRow="customRow">
      <!--
      ====================================
      # Custom row information
      ====================================
      -->


      <label class=" col-form-label no-padding-right left-pos" [ngClass]="(isShow)?'col-sm-5':'col'">
        <span class="labelWithToolTip ">{{customRow.articleName}}</span>
        <!--tooltip-item-->
        <span class="tooltip-item mt-0">
                   <span class="tooltipBox">
                     <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                   </span>
                  <span class="desc-place desc-place-view">
                  <ng-container>
                    <div>
                    {{'admin.dealer.order.custom_row_description'|translate}}
                    </div>
                  </ng-container>
              </span>
                 </span>
      </label>
      <div class="col-sm-7">
        <p class="field-place col-form-label">{{ customRow.amount | number }}</p>
      </div>
    </ng-template>

    <app-modal-basic #addCustomRowModal [dialogClass]="'modal-lg'">

    <div class="app-modal-header">
      <h4 class="modal-title">
        {{'admin.backoffice.order.custom_row'| translate }}
      </h4>
      <button type="button" class="close basic-close" (click)="resetAddCustomRow(); addCustomRowModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <form novalidate #addCustomRowForm="ngForm">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <input type="checkbox" class="border-checkbox" name="'hasCustomRow" [(ngModel)]="hasCustomRow">
            <label class="border-checkbox-label mb-0"
                   [for]="'hasCustomRow'">{{'doctrine.backoffice.order.custom_row'|translate}}</label>

            <button type="submit" class="btn btn-primary custom-btn-sm btn-sm ripple light float-right"
                    *ngIf="hasCustomRow"
                    (click)="addNewRow()">
              {{'doctrine.backoffice.order.add_custom_row' | translate}}
            </button>
          </div>
        </div>

        <div *ngIf="hasCustomRow">
          <ng-container *ngFor="let customRow of customRows; let i = index;">
            <div class="col-md-12 d-flex justify-content-between p-0">
              <p class="m-0"><b>{{'doctrine.backoffice.order.article'| translate}} {{i + 1}}</b></p>
              <button class="btn-link btn-remove-padding " type="button" *ngIf="i > 0"
                      (click)="removeCustomRow(i)">
                <i class="fa fa-trash fa-fw'"></i>
              </button>
            </div>
            <hr style="background-color: black">
            <div class="form-row row">
              <div class="form-group col">
                <label [for]="'articleName' + i">{{"doctrine.backoffice.order.article_name" | translate}}<span
                  class="star">*</span></label>
                <input required [name]="'articleName' + i"
                       [id]="'articleName' + i"
                       class="form-control"
                       #articleName="ngModel"
                       [(ngModel)]="customRow.articleName">
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="articleName.invalid && articleName.dirty && articleName.errors?.required">
                  {{'errors.required'|translate}}
                </div>
              </div>
              <div class="form-group col">
                <label [for]="'amount' + i">{{"doctrine.backoffice.order.amount" | translate}}   <span
                  class="star">*</span></label>
                <input type="number" required [name]="'amount' + i"
                       [id]="'amount' + i"
                       min="1"
                       max="99999"
                       class="form-control"
                       pattern="\d+([.]\d(\d)?)?"
                       #amount="ngModel"
                       [(ngModel)]="customRow.amount">
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="amount.invalid && amount.dirty && amount.errors?.required">
                  {{'errors.required'|translate}}
                </div>
                <div class="messages text-danger"
                     *ngIf="amount.invalid && amount.dirty && amount.errors?.pattern">
                  {{'errors.invalid'|translate}}
                </div>
              </div>
            </div>
            <p>{{'doctrine.backoffice.order.price'| translate}}</p>
            <hr>
            <div class="form-row row">
              <div class="form-group col">
                <label [for]="'price' + i">{{"doctrine.backoffice.order.price_reduction" | translate}} <span
                  class="star">*</span></label>
                <input required [name]="'price' + i"
                       type="number"
                       step="0.01"
                       min="0"
                       max="99999"
                       [id]="'price' + i"
                       class="form-control"
                       #price="ngModel"
                       [(ngModel)]="customRow.price">
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="price.invalid && price.dirty && price.errors?.required">
                  {{'errors.required'|translate}}
                </div>
                <div class="messages text-danger"
                     *ngIf="price.invalid && price.dirty && price.errors?.pattern">
                  {{'errors.invalid'|translate}}
                </div>
              </div>

              <div class="form-group col">
                <label [for]="'supplier' + i">{{'doctrine.backoffice.order.supplier'|translate}} <span
                  class="star">*</span></label>
                <ng-select [(ngModel)]="customRow.supplier" [id]="'supplier' + i" [name]="'supplier' + i"
                           #supplierItem="ngModel" [searchable]="false" [clearable]="false" required>
                  <ng-option *ngFor="let supplier of suppliers"
                             [value]="supplier.id">{{supplier.companyName}} </ng-option>
                </ng-select>
                <div class="messages text-danger"
                     *ngIf="supplierItem.invalid && supplierItem.dirty && supplierItem.errors?.required">{{'errors.required'|translate}}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div class="app-modal-footer">

      <button type="button" class="btn btn-simple ripple me-4"
              (click)="resetAddCustomRow(); addCustomRowModal.hide();">{{'global.cancel'|translate}}</button>

      <button type="button" class="btn btn-primary ripple light" (click)="manageCustomRow()"
              [disabled]="addCustomRowForm.invalid">
        {{(editCustomRow ? 'global.actions.save' : 'global.add')| translate}}
      </button>
    </div>
  </app-modal-basic>
    <app-modal-basic #addDiscountModal [dialogClass]="'modal-lg'">

      <div class="app-modal-header">
        <h4 class="modal-title">
          {{'admin.backoffice.order.discount.title'| translate }}
        </h4>
        <button type="button" class="close basic-close" (click)="addDiscountModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body">
        <form #addDiscountForm="ngForm">
          <div class="form-row row">
            <div class="form-group col">
              <label for='discountType'>{{"admin.backoffice.order.discount.type" | translate}}</label>
              <ng-select class="select-box"
                          name='discountType'
                         [items]="discountTypeOptions"
                         [clearable]="false"
                         [(ngModel)]="discount.type"
                         (change)="changeDiscount($event)"
                         bindValue="value" bindLabel="label">
              </ng-select>
            </div>
            <div *ngIf="discount.type === Discount.TYPE_AMOUNT" class="form-group col">
              <label for='discountAmount'>{{"admin.backoffice.order.discount.amount" | translate}}</label>
              <input required name='discountAmount'
                     type="number"
                     step="0.01"
                     min="0"
                     max="99999999999"
                     id='discountAmount'
                     class="form-control"
                     (ngModelChange)="castDiscount($event)"
                     [(ngModel)]="discount.amount">
              <span class="form-bar"></span>
              <div class="messages text-danger"
                   *ngIf="addDiscountForm.invalid && addDiscountForm.dirty && addDiscountForm.errors?.required">
                {{'errors.required'|translate}}
              </div>
            </div>
            <div *ngIf="discount.type === Discount.TYPE_PERCENTAGE" class="form-group col">
              <label for='discountPercent'>{{"admin.backoffice.order.discount.percent" | translate}}</label>
              <input required name='discountPercent'
                     type="number"
                     step="0.01"
                     min="0"
                     max="100"
                     id='discountPercent'
                     class="form-control"
                     (ngModelChange)="castDiscount($event)"
                     [(ngModel)]="discount.percentage">
              <span class="form-bar"></span>
              <div class="messages text-danger"
                   *ngIf="addDiscountForm.invalid && addDiscountForm.dirty && addDiscountForm.errors?.required">
                {{'errors.required'|translate}}
              </div>
            </div>
            <div class="form-group col">
              <div class="d-flex h-100 align-items-end">
                <span class="mb-1">≈ {{discount.type === Discount.TYPE_PERCENTAGE ? '€' : '%'}}{{discount.applied}}</span>
              </div>
            </div>
          </div>
          <div class="form-row row">
            <div class="form-group col">
              <label for="discount-supplier">{{'doctrine.backoffice.order.discount_on'|translate}} <span
                class="star">*</span></label>
              <ng-select [(ngModel)]="discount.supplierId" id="discount-supplier" name="discount-supplier"
                         #discountSupplier="ngModel" [searchable]="false" (change)="updateDiscount()" [clearable]="false" required>
                <ng-option [value]="0">
                  {{'doctrine.backoffice.order.whole'|translate}}
                </ng-option>
                <ng-option *ngFor="let supplier of suppliers"
                           [value]="supplier.id">{{supplier.companyName}} </ng-option>
              </ng-select>
              <div class="messages text-danger"
                   *ngIf="discountSupplier.invalid && discountSupplier.dirty && discountSupplier.errors?.required">{{'errors.required'|translate}}
              </div>
            </div>
          </div>
          <div class="form-row row">
            <div class="form-group col">
              <label for="discount-description">{{'doctrine.backoffice.order.description' | translate}}</label>
              <textarea name="discount-description" id="discount-description" cols="30" rows="10" class="form-control"
                        #discountDescription="ngModel" [(ngModel)]="discount.description"></textarea>
              <div class="messages text-danger"
                   *ngIf="discountDescription.invalid && discountDescription.dirty && discountDescription.errors.required">
                {{'errors.required'|translate}}
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="app-modal-footer">

        <button type="button" class="btn btn-simple ripple me-4"
                (click)="addDiscountModal.hide()">{{'global.cancel' | translate}}</button>

        <button *ngIf="this.order && this.order.discount.applied > 0" type="button" class="btn btn-outline-secondary ripple me-4"
                (click)="removeDiscount()">{{'global.remove' | translate}}</button>

        <button type="button" class="btn btn-primary ripple light" (click)="manageDiscount()"
                [disabled]="addDiscountForm.invalid">
          {{'global.actions.save' | translate}}
        </button>
      </div>
    </app-modal-basic>
    <app-modal-basic [hideHeader]="true" #cancelPlaceOrderModal>
      <div class="app-modal-body">
        <p class="mb-0">{{ 'global.cancel_place_order_body' | translate}}</p>
      </div>
      <div class="app-modal-footer">
        <button type="button" class="btn btn-simple ripple btn-popup"
                (click)="cancelPlaceOrderModal.hide()">{{'global.cancel'|translate}}</button>
        <button type="button" class="btn btn-primary ripple btn-popup light ms-1"
                (click)="redirectToDashboard()">{{'global.ok'|translate}}</button>
      </div>
    </app-modal-basic>
  </div>
</form>
